/* ============================================================================
   wl-cart-drawer-opt.js  —  Cart-drawer performance optimizer (Phase 1)
   ----------------------------------------------------------------------------
   FLAG-GATED (default ON).  Runs for every shopper unless explicitly disabled.
     Disable:  add ?wlopt=0 to any store URL (persists in localStorage)
     Re-enable: add ?wlopt=1   (or run localStorage.removeItem('wlCartOpt'))

   When ON it PRE-EMPTS the drawer's original quantity / size / wishlist
   handlers (capture phase) and replaces their slow flows:
       - quantity  : core full section re-render on EVERY click (+ dim)
       - size      : /cart.js -> /cart/clear -> /cart/add -> full reload  (~5 trips + dim)
       - wishlist  : /cart.js -> /cart/change -> full reload             (3 trips + dim)
   ...with:
       - instant OPTIMISTIC feedback (no whole-drawer dim)
       - DEBOUNCED / COALESCED network calls (holding +/- = one request)
       - a SINGLE server-rendered re-render reusing the drawer's own pipeline
         (window.wlDrawerAPI.applyFromHTML) so coupon/ETA/recs stay correct.

   Safe: on any error it falls back to the original full reload, and it never
   runs when the flag is off.  Loaded in <head> (before the drawer's inline
   script) so its capture listeners fire first.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- feature flag ------------------------------------------------------
     DEFAULT-ON for all shoppers (the native path does a full section re-render +
     greys the cart on every click, which reads as a 2-3s "blur then update").
     `?wlopt=0` disables it (persisted) as an escape hatch; `?wlopt=1` re-enables. */
  try {
    var sp = new URLSearchParams(location.search);
    if (sp.has('wlopt')) {
      var v = (sp.get('wlopt') || '').toLowerCase();
      if (v === '0' || v === 'off' || v === 'false') localStorage.setItem('wlCartOpt', '0');
      else localStorage.removeItem('wlCartOpt');
    }
  } catch (e) {}
  var ON = true;
  try { if (localStorage.getItem('wlCartOpt') === '0') ON = false; } catch (e) {}
  if (!ON) return;
  if (window.__wlCartOptInit) return;
  window.__wlCartOptInit = true;
  try { console.info('%c[wl-cart-opt]', 'color:#a8496c;font-weight:bold', 'Phase-1 drawer optimizer ON — disable with ?wlopt=0'); } catch (e) {}

  /* ---- helpers ----------------------------------------------------------- */
  var SID = 'cart-drawer';
  function dlg() { return document.getElementById('CartDrawer'); }
  function inDrawer(el) { var d = dlg(); return !!(d && el && d.contains(el)); }
  function lineRows() { var d = dlg(); return d ? d.querySelectorAll('.hdt-mini-cart__items hdt-line-item') : []; }
  function api() { return window.wlDrawerAPI || null; }

  /* per-line pending state (a light fade on the affected row — NOT a whole-drawer dim) */
  (function () {
    var s = document.createElement('style');
    s.setAttribute('data-wl-opt', '');
    /* NOTE: we deliberately do NOT fade/grey the row (that read as "hung"). We only
       lock the controls that are mid-flight so a second click can't race the request. */
    s.textContent =
      '#CartDrawer .hdt-line-item.wl-opt-pending .wl-size,#CartDrawer .hdt-line-item.wl-opt-pending .wl-size__btn{pointer-events:none}' +
      /* Money is server-exact, so there is always a round trip between the click and
         the new figure. During that wait the figures soften VERY slightly so the old
         value does not read as stale/wrong, then ease back to full strength when the
         exact figure lands. Deliberately NO blur and NO vertical movement - both of
         those read as a flicker/jump. It is a calm opacity dip only. The old value
         stays on screen throughout - nothing invented is ever shown. */
      '#CartDrawer .hdt-mini-cart__price,#CartDrawer [data-wl-grandtotal],#CartDrawer [data-wl-savedamt],' +
      '#hdt-page-cart .wl-cart-item__price,#hdt-page-cart [data-wl-grandtotal]{' +
      'transition:opacity .16s ease}' +
      '.wl-opt-busy .hdt-mini-cart__price,.wl-opt-busy [data-wl-grandtotal],.wl-opt-busy [data-wl-savedamt],' +
      '.wl-opt-busy .wl-cart-item__price{opacity:.62}' +
      '.wl-opt-settled .hdt-mini-cart__price,.wl-opt-settled [data-wl-grandtotal],.wl-opt-settled [data-wl-savedamt],' +
      '.wl-opt-settled .wl-cart-item__price{animation:wlOptLand .26s ease}' +
      '@keyframes wlOptLand{from{opacity:.62}to{opacity:1}}' +
      '@media (prefers-reduced-motion:reduce){' +
      '.wl-opt-busy .hdt-mini-cart__price,.wl-opt-busy [data-wl-grandtotal],.wl-opt-busy [data-wl-savedamt],' +
      '.wl-opt-busy .wl-cart-item__price{opacity:.72}' +
      '.wl-opt-settled .hdt-mini-cart__price,.wl-opt-settled [data-wl-grandtotal],.wl-opt-settled [data-wl-savedamt],' +
      '.wl-opt-settled .wl-cart-item__price{animation:none}}' +
      /* Removal reads as a card being dealt off the deck: it slides aside and fades,
         then the stack closes over it. The motion is what covers the server round
         trip, so it must not be shortened below the response time.
         Both selectors are needed - the row is a <hdt-line-item> element which does
         not always carry a matching class. */
      'hdt-line-item.wl-opt-removing,#CartDrawer .hdt-mini-cart__items hdt-line-item.wl-opt-removing{' +
        'overflow:hidden!important;pointer-events:none;min-height:0!important;box-shadow:none!important;' +
        'will-change:height,transform,opacity;' +
        /* opacity is DELAYED so the card is still solid while it slides under its
           neighbour - fading it immediately hid the tuck and just looked like a blur */
        'transition:transform .34s cubic-bezier(.4,.02,.5,1),opacity .12s ease .2s,' +
        'height .34s cubic-bezier(.4,0,.2,1),border-width .34s linear,' +
        'margin .34s cubic-bezier(.4,0,.2,1),padding .34s cubic-bezier(.4,0,.2,1)}' +
      /* collapse the border too, otherwise the row bottoms out a couple of pixels
         short and the stack finishes with a small snap */
      /* Removal is the visual INVERSE of arrival: the card drops a little and tucks
         BEHIND its neighbour (z-index below the surviving rows) while the stack
         closes over it. */
      'hdt-line-item.wl-opt-slide,#CartDrawer .hdt-mini-cart__items hdt-line-item.wl-opt-slide{' +
        'position:relative;z-index:0;transform-origin:50% 100%;' +
        'transform:translateY(20px) scale(.93);opacity:0}' +
      '#CartDrawer .hdt-mini-cart__items:has(hdt-line-item.wl-opt-removing) hdt-line-item:not(.wl-opt-removing){' +
        'position:relative;z-index:1;background:#fff}' +
      /* collapse the border AND padding too. The theme sets the row's padding with
         !important, so an inline style:padding=0 never wins and the row bottomed out
         at 22px (11px top + 11px bottom) before snapping away. */
      'hdt-line-item.wl-opt-collapse,#CartDrawer .hdt-mini-cart__items hdt-line-item.wl-opt-collapse{' +
        'border-width:0!important;padding-top:0!important;padding-bottom:0!important;' +
        'margin-top:0!important;margin-bottom:-14px!important}' +
      /* ARRIVAL: a new line is dealt out from BEHIND the row above it - it starts
         tucked up and slightly small with a lower stacking order, then slides down
         into its slot. z-index keeps it under its neighbours while it travels.
         `transition:none` on the start state is essential: the theme already puts a
         .34s transform transition on every row, so without it the START state
         animated in too and the row never reached its offset - only the fade showed. */
      /* ARRIVAL: the stack OPENS UP to make room and the new card rises into the gap
         from underneath the cards above it (z-index below them, so it really is
         occluded on the way in) - the mirror image of the removal tuck.
         Two classes: `wl-opt-anim` carries the transition and stays for the whole
         animation, `wl-opt-arriving` is the start state and is REMOVED to trigger it.
         The start state must carry `transition:none` because the theme already puts a
         .34s transform transition on every row - without it the start state animated
         in as well and the row never reached its offset, so only the fade showed. */
      'hdt-line-item.wl-opt-anim,#CartDrawer .hdt-mini-cart__items hdt-line-item.wl-opt-anim{' +
        'overflow:hidden!important;position:relative;z-index:0;min-height:0!important;' +
        'will-change:height,transform,opacity;' +
        'transition:height .44s cubic-bezier(.2,.9,.3,1),transform .46s cubic-bezier(.2,.9,.3,1),' +
        'opacity .3s ease .08s,padding .44s cubic-bezier(.2,.9,.3,1),' +
        'margin .44s cubic-bezier(.2,.9,.3,1),border-width .44s linear!important}' +
      'hdt-line-item.wl-opt-arriving,#CartDrawer .hdt-mini-cart__items hdt-line-item.wl-opt-arriving{' +
        'transform:translateY(-34px) scale(.93);opacity:0;transform-origin:50% 0;' +
        'padding-top:0!important;padding-bottom:0!important;border-width:0!important;' +
        'margin-bottom:-14px!important;transition:none!important}' +
      /* every other card sits ABOVE the incoming one so it slides out from behind them */
      '#CartDrawer .hdt-mini-cart__items:has(hdt-line-item.wl-opt-anim) hdt-line-item:not(.wl-opt-anim){' +
        'position:relative;z-index:1;background:#fff}' +
      /* existing line, quantity +1: nothing arrived, so just pulse the card */
      'hdt-line-item.wl-opt-bumped,#CartDrawer .hdt-mini-cart__items hdt-line-item.wl-opt-bumped{' +
        'transition:box-shadow .3s ease,transform .3s ease;' +
        'transform:scale(1.012);box-shadow:0 0 0 2px rgba(168,73,108,.35)!important}' +
      'hdt-line-item.wl-opt-bumped.wl-opt-arrived,#CartDrawer .hdt-mini-cart__items hdt-line-item.wl-opt-bumped.wl-opt-arrived{' +
        'transform:none;box-shadow:0 0 0 0 rgba(168,73,108,0)!important;transition:box-shadow .5s ease .25s,transform .35s ease}' +
      /* cart page rows get the same tuck-behind treatment */
      '#hdt-page-cart .wl-cart-item.is-removing{position:relative;z-index:0;' +
        'transform-origin:50% 100%;will-change:height,transform,opacity;' +
        'transition:transform .34s cubic-bezier(.4,.02,.5,1),opacity .12s ease .2s,' +
        'height .34s cubic-bezier(.4,0,.2,1),padding .34s cubic-bezier(.4,0,.2,1)}' +
      '#hdt-page-cart .wl-cart-item:not(.is-removing){position:relative;z-index:1}' +
      '#hdt-page-cart .wl-cart-item.wl-opt-slide{transform:translateY(20px) scale(.93);opacity:0}' +
      /* "Added" confirmation on the recommendation card itself - cheaper and calmer
         than re-shuffling the carousel to drop the card out of it */
      '#CartDrawer .wl-rec-add.is-added{background:#2f6a48!important;box-shadow:0 8px 16px -8px rgba(47,106,72,.7)!important}' +
      '#CartDrawer .wl-rec-add.is-added svg{width:12px;height:12px}' +
      /* bill rows that exist at zero are toggled with [hidden]; the row rule sets
         display:flex, which would otherwise win over the attribute's default */
      '#CartDrawer .wl-bill__row[hidden]{display:none!important}' +
      /* Removing the last coupon drops `is-applied`, which hands the cell back to the
         "Apply coupon" trigger. But that also switches on the automatic-offer rule
         `:not(.is-applied) .hdt-cart-coupon__applied{height:auto;margin-top:6px}`, and
         with the chip already hidden the leftover 6px margin nudged the row 74->80px.
         The container is empty during the swap, so collapse it until the render lands. */
      '#CartDrawer .hdt-cart-coupon.wl-cc-collapsing .hdt-cart-coupon__applied{' +
        'height:0!important;margin-top:0!important}' +
      /* quantity buttons: clear default colour + an obviously-dead disabled state */
      '#CartDrawer .hdt-quantity-wrapper .hdt-quantity__button{color:#2A1A15!important;opacity:1!important;cursor:pointer;transition:color .15s ease,opacity .15s ease}' +
      '#CartDrawer .hdt-quantity-wrapper .hdt-quantity__button:hover:not(:disabled):not([disabled]){color:#a8496c!important}' +
      '#CartDrawer .hdt-quantity-wrapper .hdt-quantity__button:disabled,#CartDrawer .hdt-quantity-wrapper .hdt-quantity__button[disabled]{color:#CFC6BB!important;opacity:.45!important;cursor:not-allowed!important;pointer-events:none!important}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function notice(msg) {
    try {
      var n = document.getElementById('wl-cart-notice');
      if (!n) { n = document.createElement('div'); n.id = 'wl-cart-notice'; n.className = 'wl-cart-notice'; document.body.appendChild(n); }
      n.textContent = msg || 'Couldn\u2019t update your bag \u2014 please try again.';
      n.classList.add('is-show');
      clearTimeout(n._t); n._t = setTimeout(function () { n.classList.remove('is-show'); }, 3200);
    } catch (e) {}
  }

  /* keep header / badge counts in step (core's cart:update is suppressed while we drive) */
  function syncCount(n) {
    if (n == null) return;
    document.querySelectorAll('hdt-cart-count, [data-cart-count], .hdt-cart-count, .cart-count-bubble, .hdt-header__action--cart .hdt-count')
      .forEach(function (el) { el.textContent = n; });
  }

  /* NOTE: sections_url MUST be '/' — the cart-drawer section is NOT rendered on the
     /cart page, so requesting it with '/cart' returns markup with no #CartDrawer and
     zero line items (which silently left stale rows on screen). */
  function withSections(body) { body.sections = [SID]; body.sections_url = '/'; return body; }
  function postJSON(url, body) {
    /* Anything that mutates the cart makes a warmed /cart.js copy stale, and a stale
       copy feeds the destructive clear -> add rebuild. Invalidate centrally. */
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) invalidateCart();
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) { var er = new Error('http-' + r.status); er.res = r; throw er; } return r.text().then(function (t) { return JSON.parse(t); }); });
  }
  /* hand the freshly-rendered section HTML to the drawer's OWN re-render pipeline
     (relocates coupon/recs, refreshes ETAs, count, coupon-pop, etc.).
     opts.keepRecs preserves the "You may also love" block across re-renders. */
  function applyFrom(data, opts) {
    var html = data && data.sections && data.sections[SID];
    /* Only trust a payload that actually contains the drawer markup; otherwise fall
       back to the full reload so the UI can never be left stale. */
    if (html && html.indexOf('CartDrawer') !== -1 && api() && typeof api().applyFromHTML === 'function') {
      if (api().applyFromHTML(html, opts || {}) !== false) return true;
    }
    if (api() && typeof api().reload === 'function') { api().reload(); return true; }
    return false;
  }
  function fail() { notice(); if (api() && api().reload) try { api().reload(); } catch (e) {} }

  /* Show the just-wishlisted product in "You may also love" with ONE surgical insert.
     The previous approach fired a full strip re-sync three times, and each re-sync
     tripped the drawer's own observer into another one: measured 11 DOM mutations with
     the slide count flapping 5<->6 and the carousel jumping. One retry covers the case
     where the block is still loading its own products when the heart is clicked. */
  function showWished(pid) {
    if (!pid) return;
    var tries = 0;
    (function attempt() {
      var ok = false;
      if (api() && api().addWished) { try { ok = api().addWished(pid); } catch (e) {} }
      if (!ok && ++tries < 3) setTimeout(attempt, 500);
    })();
  }

  function animateOut(el) {
    if (!el) return;
    try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { el.style.display = 'none'; return; } } catch (e) {}
    var h = el.offsetHeight;
    el.style.height = h + 'px';
    el.getBoundingClientRect();
    el.classList.add('wl-opt-removing');
    /* Slide and collapse TOGETHER. Collapsing 150ms later left the row invisible but
       still occupying its slot - a white hole opened between the neighbours, which is
       exactly the "empty space" complaint. Running them concurrently means the stack
       closes over the card as it drops behind, so no gap is ever visible. The fade is
       delayed to the last third so the tuck-behind is actually seen. */
    requestAnimationFrame(function () {
      el.classList.add('wl-opt-slide', 'wl-opt-collapse');
      el.style.height = '0px';
      el.style.marginTop = '0'; el.style.marginBottom = '0';
      el.style.paddingTop = '0'; el.style.paddingBottom = '0';
    });
  }
  /* Detach the collapsed row once its transition has finished. It is already at
     height 0 by then, so this is invisible - it just stops the node lingering.
     Must wait for HEIGHT specifically: transform/opacity finish earlier, and
     detaching on those would snap the stack shut instead of letting it slide. */
  function dropRow(row) {
    if (!row) return;
    var done = false;
    var kill = function () { if (done) return; done = true; if (row.parentNode) row.parentNode.removeChild(row); };
    row.addEventListener('transitionend', function (e) { if (!e.propertyName || e.propertyName === 'height') kill(); });
    setTimeout(kill, 700);
  }

  /* ================= QUANTITY (optimistic + debounced/coalesced) ========== */
  var qTimer = {}, qSeq = {};
  function rowOf(el) { return el.closest('hdt-line-item'); }
  function qInput(row) { return row ? row.querySelector('input[name="updates[]"]') : null; }
  function lineOf(row) { var i = qInput(row); return i ? (parseInt(i.getAttribute('data-index'), 10) || null) : null; }
  /* Shopify's `line` is POSITIONAL and re-indexes the moment any line is removed, so a
     request built with a line number captured earlier can land on a DIFFERENT product
     or on a line that no longer exists (422).
     The line-item KEY is not the answer either: Shopify ROTATES it on every mutation
     (`...:9c02cd16` became `...:54ea733e` after one quantity change), so a key captured
     a moment ago returns "no valid id or line parameter" (400).
     The VARIANT id is stable for the life of the line, and `/cart/change.js` accepts it
     as `id`. It is only ambiguous if the same variant occupies two lines (different
     line properties), so fall back to the positional line in that case. */
  function lineRef(row, line) {
    var vid = row && row.getAttribute && row.getAttribute('data-wl-vid');
    if (vid) {
      var twins = 0;
      rowsLive().forEach(function (r) { if (r.getAttribute('data-wl-vid') === vid) twins++; });
      if (twins <= 1) return { id: vid };
    }
    return { line: line };
  }

  /* ---- money: ALWAYS integer cents from data attributes, NEVER parsed text ------
     Parsing formatted money is unsafe (e.g. "₹1,299.50" would read back as 129950),
     so every figure carries an exact `data-cents` written by Liquid, and all maths is
     done in integer cents. */
  function attrInt(el, name) { if (!el) return 0; var v = parseInt(el.getAttribute(name), 10); return isNaN(v) ? 0 : v; }
  function fmtCents(cents) {
    var neg = cents < 0; cents = Math.abs(Math.round(cents));
    var r = Math.floor(cents / 100), p = cents % 100, s;
    try { s = r.toLocaleString('en-IN'); } catch (e) { s = String(r); }
    if (p) s += '.' + (p < 10 ? '0' + p : p);
    return (neg ? '-' : '') + '\u20B9' + s;
  }
  function setCents(el, cents, prefix) {
    if (!el) return;
    el.setAttribute('data-cents', String(Math.round(cents)));
    el.textContent = (prefix || '') + fmtCents(cents);
  }

  function rowsAll() { var d = dlg(); return d ? [].slice.call(d.querySelectorAll('.hdt-mini-cart__items hdt-line-item')) : []; }
  function rowsLive() { return rowsAll().filter(function (r) { return !r.hasAttribute('data-wl-gone'); }); }
  function rowQty(row) { var i = qInput(row); return i ? (parseInt(i.value, 10) || 0) : 0; }
  function cartDiscountCents() {
    var d = dlg(); var el = d && d.querySelector('[data-wl-grandtotal]');
    return el ? attrInt(el, 'data-cart-discount-cents') : 0;
  }

  /* ================= EXACT MONEY (no prediction, ever) =====================
     Every amount displayed comes from the server. We never derive, scale or add up
     money on the client. The speed comes from asking for a TINY dedicated section
     (`wl-cart-money`, ~0.3KB) in the SAME request as the cart mutation, instead of
     re-rendering the whole 137KB drawer, and from writing the returned values into
     the existing nodes rather than replacing the DOM. */
  var MONEY_SID = 'wl-cart-money';
  function withMoney(body) { body.sections = [MONEY_SID]; body.sections_url = '/'; return body; }
  /* Only the NEWEST line's markup plus the exact figures. `/cart/add.js` prepends, so
     the newest line is the one just added. Asking for the whole cart-drawer section
     instead cost ~650ms and ~161KB; asking for every row costs ~20KB more than this for
     rows we already have on screen. */
  var NEWLINE_SID = 'wl-cart-newline';
  function withNewLineAndMoney(body) { body.sections = [NEWLINE_SID, MONEY_SID]; body.sections_url = '/'; return body; }
  /* Emptying the cart is the ONE mutation whose result cannot be patched into the
     existing DOM - it needs Liquid's empty-state markup, which the money section does
     not carry. That used to be fetched in a SECOND round trip fired only after the
     mutation replied, so the shopper watched a completely blank drawer for the whole
     of it (measured: row gone at 439ms, empty state at 1514ms = 1075ms of nothing).
     When we can tell in advance that a removal empties the cart, ask for the drawer
     section in the SAME request. */
  function withMoneyAndDrawer(body) { body.sections = [MONEY_SID, SID]; body.sections_url = '/'; return body; }

  function parseMoneyEl(data) {
    var html = data && data.sections && data.sections[MONEY_SID];
    if (!html) return null;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.getElementById('wl-cart-money');
    } catch (e) { return null; }
  }

  /* Rebuild the bill's discount rows from the server's own per-row title/amount lists.
     No arithmetic: every figure and label is a string the server rendered. Returns
     false only if the template anchor is missing or the server's three lists disagree,
     in which case the caller still takes an authoritative render. */
  function splitList(s) { s = s || ''; return s.length ? s.split('|') : []; }
  function syncDiscountRows(d, moneyEl) {
    var anchor = d.querySelector('[data-wl-bill-discs]');
    if (!anchor || !anchor.parentNode) return false;
    var n = parseInt(moneyEl.getAttribute('data-disc-count') || '0', 10) || 0;
    var titles = splitList(moneyEl.getAttribute('data-disc-titles'));
    var monies = splitList(moneyEl.getAttribute('data-disc-money'));
    var cents = splitList(moneyEl.getAttribute('data-disc-amounts'));
    if (titles.length !== n || monies.length !== n || cents.length !== n) return false;
    var rows = [].slice.call(d.querySelectorAll('[data-wl-bill-disc]'));
    /* drop the rows the server no longer applies */
    for (var i = n; i < rows.length; i++) {
      var gone = rows[i].closest('.wl-bill__row');
      if (gone && gone.parentNode) gone.parentNode.removeChild(gone);
    }
    for (var j = 0; j < n; j++) {
      var amt = rows[j];
      if (!amt) {
        var row = document.createElement('div');
        row.className = 'wl-bill__row';
        var lab = document.createElement('span');
        amt = document.createElement('span');
        amt.className = 'wl-bill__save';
        amt.setAttribute('data-wl-bill-disc', '');
        row.appendChild(lab);
        row.appendChild(amt);
        anchor.parentNode.insertBefore(row, anchor);
      }
      /* the WINNING discount can change identity as the subtotal crosses a tier (a
         better code displaces the automatic offer), so the label is as volatile as
         the amount and is repainted from the server's title too. */
      var labEl = amt.parentNode.querySelector('span');
      if (labEl && labEl !== amt) labEl.textContent = 'Discount (' + titles[j] + ')';
      amt.setAttribute('data-cents', cents[j]);
      amt.textContent = '\u2212 ' + monies[j];
      if (n === 1) amt.setAttribute('data-wl-bill-coupon', '');
      else amt.removeAttribute('data-wl-bill-coupon');
    }
    return true;
  }
  /* Writes the server's own figures verbatim. Returns false when the drawer's
     structure can't represent them (a row appeared/disappeared, a bill row is
     missing, a shipping bar needs recalculating) so the caller can fall back to a
     full authoritative render instead of showing a half-updated panel. */  function applyExactMoney(moneyEl, opts) {
    var d = dlg(); if (!d || !moneyEl) return false;
    opts = opts || {};
    var lineCount = parseInt(moneyEl.getAttribute('data-line-count'), 10);
    var prodSav = parseInt(moneyEl.getAttribute('data-prod-savings'), 10) || 0;
    var savings = parseInt(moneyEl.getAttribute('data-savings'), 10) || 0;
    var cartDisc = parseInt(moneyEl.getAttribute('data-cart-discount'), 10) || 0;

    if (!opts.allowRowCountChange && lineCount !== rowsLive().length) return false;
    /* a free-shipping bar is a function of the total and is rendered by Liquid only */
    if (d.querySelector('.hdt-mini-cart__threshold')) return false;
    /* The "Discount on MRP" row is always in the markup now, hidden at zero, so its
       appearance is a toggle rather than a structural change. */
    var pdEl = d.querySelector('[data-wl-bill-proddisc]');
    if (!pdEl) return false;
    var pdRow = pdEl.closest('.wl-bill__row');
    if (pdRow) { if (prodSav > 0) pdRow.removeAttribute('hidden'); else pdRow.setAttribute('hidden', ''); }
    /* One bill row per discount, rebuilt from the server's own per-row figures.
       This used to bail whenever the NUMBER of discounts changed, which meant every
       add that crossed a reward tier took a full drawer re-render - destroying the
       just-inserted line before it could animate in. */
    if (!syncDiscountRows(d, moneyEl)) return false;
    if (savings > 0 && !d.querySelector('[data-wl-savedamt]')) return false;
    if (savings === 0 && d.querySelector('[data-wl-savedamt]')) return false;

    var put = function (sel, centsAttr, moneyAttr) {
      var el = d.querySelector(sel); if (!el) return;
      el.setAttribute('data-cents', moneyEl.getAttribute(centsAttr) || '0');
      el.textContent = moneyEl.getAttribute(moneyAttr) || '';
    };
    put('[data-wl-totalnow]', 'data-total', 'data-money-total');
    put('[data-wl-origtotal]', 'data-orig-total', 'data-money-orig');
    put('[data-wl-bill-mrp]', 'data-orig-total', 'data-money-orig');
    put('[data-wl-savedamt]', 'data-savings', 'data-money-savings');
    var pd = d.querySelector('[data-wl-bill-proddisc]');
    if (pd) { pd.setAttribute('data-cents', String(prodSav)); pd.textContent = '\u2212 ' + (moneyEl.getAttribute('data-money-prod-savings') || ''); }
    var g = d.querySelector('[data-wl-grandtotal]');
    if (g) g.setAttribute('data-cart-discount-cents', String(cartDisc));

    var count = moneyEl.getAttribute('data-item-count');
    var host = document.querySelector('hdt-cart-drawer');
    if (host) {
      host.setAttribute('data-count', count);
      host.setAttribute('data-wl-hidden-lines', moneyEl.getAttribute('data-hidden-lines') || '0');
    }
    var badge = d.querySelector('.wl-vc-count'); if (badge) badge.textContent = count;
    syncCount(count);
    applyRewards(moneyEl.getAttribute('data-subtotal'), moneyEl.getAttribute('data-cart-discount'));
    return true;
  }

  /* ================= REWARDS milestone bar ================================
     Driven by the SERVER's `cart.items_subtotal_price` (goods value before any
     cart-level discount). Using the discounted total would oscillate: crossing a tier
     applies a discount, which drops the total back under the tier, which removes it.
     The only arithmetic here is exact integer-cent subtraction for the "add ₹X more"
     hint and a percentage for the bar width - no price is ever derived or displayed
     from a client calculation. */
  function applyRewards(subtotalAttr, savedAttr) {
    var subtotal = parseInt(subtotalAttr, 10);
    if (isNaN(subtotal)) return;
    var saved = parseInt(savedAttr, 10);
    if (isNaN(saved)) saved = -1;
    [].slice.call(document.querySelectorAll('[data-wl-rewards]')).forEach(function (box) {
      var tiers = (box.getAttribute('data-tiers') || '').split(',').map(function (v) { return parseInt(v, 10); }).filter(function (v) { return !isNaN(v); });
      var labels = (box.getAttribute('data-labels') || '').split('|');
      if (!tiers.length) return;
      var max = tiers[tiers.length - 1];
      /* Previous value is remembered on the ELEMENT, not re-read from the DOM: a
         structural server render repaints the bar already showing `is-on`, so comparing
         against the markup would miss the unlock and swallow the celebration. The box
         node itself survives those renders (only its innerHTML is swapped). */
      var prev = typeof box.__wlSub === 'number' ? box.__wlSub : parseInt(box.getAttribute('data-subtotal'), 10);
      if (isNaN(prev)) prev = subtotal;
      box.__wlSub = subtotal;
      box.setAttribute('data-subtotal', String(subtotal));

      var pct = railPct(subtotal, tiers);
      var fill = box.querySelector('[data-wl-rw-fill]');
      if (fill) fill.style.width = pct + '%';
      var track = box.querySelector('.wl-rw__track');
      if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));

      tiers.forEach(function (t, i) {
        var node = box.querySelector('[data-wl-rw-node="' + i + '"]');
        if (!node) return;
        var on = subtotal >= t;
        var justEarned = on && prev < t;
        node.classList.toggle('is-on', on);
        if (justEarned && !reduceMotion()) {
          node.classList.add('wl-rw-pop');
          setTimeout(function () { node.classList.remove('wl-rw-pop'); }, 640);
          celebrate(box);
        }
      });

      box.classList.toggle('is-complete', subtotal >= max);
      /* How many tiers are banked — drives the offer strip's colour. */
      var stage = 0;
      for (var s = 0; s < tiers.length; s++) { if (subtotal >= tiers[s]) stage = s + 1; }
      box.setAttribute('data-stage', String(stage));
      /* Mark the reward currently being chased so it can breathe and keep a hint of its
         colour — without it the rail sits inert while everything is still locked. */
      [].slice.call(box.querySelectorAll('[data-wl-rw-node]')).forEach(function (n, i) {
        n.classList.toggle('is-next', i === stage && stage < tiers.length);
      });

      var nextIdx = -1;
      for (var i = 0; i < tiers.length; i++) { if (subtotal < tiers[i]) { nextIdx = i; break; } }

      var msg = box.querySelector('[data-wl-rw-msg]');
      if (msg) {
        var html = nextIdx === -1
          ? '<span class="wl-rw__done">Congrats! You\u2019ve unlocked every reward</span>'
          : 'You\u2019re <b>' + fmtCents(tiers[nextIdx] - subtotal) + '</b> away from <b>' +
            (labels[nextIdx] || 'your reward') + '</b>';
        if (msg.innerHTML !== html) msg.innerHTML = html;
      }

      var banner = box.querySelector('[data-wl-rw-banner]');
      if (banner) {
        /* The strip IS the headline — there is no separate message line any more. It
           carries BOTH halves: what is already banked (the server's own
           `cart.total_discount`, never a projection) and what the next reward costs. */
        var effSaved = saved >= 0 ? saved : parseInt(box.getAttribute('data-saved'), 10) || 0;
        if (saved >= 0) box.setAttribute('data-saved', String(saved));
        var gap = nextIdx === -1 ? 0 : (tiers[nextIdx] - subtotal);
        var nextTxt = nextIdx === -1 ? '' : ('<b>' + fmtCents(gap) + '</b> more for ' + (labels[nextIdx] || 'your reward'));
        var bhtml;
        if (effSaved > 0) {
          bhtml = '<b>' + fmtCents(effSaved) + '</b> off with offers' + (nextTxt ? ' <em>\u00b7</em> ' + nextTxt : '');
        } else if (nextIdx !== -1) {
          bhtml = '<b>' + fmtCents(gap) + '</b> away from ' + (labels[nextIdx] || 'your reward');
        } else {
          bhtml = 'Every reward unlocked';
        }
        if (banner.innerHTML !== bhtml) banner.innerHTML = bhtml;
      }
    });
  }

  /* Position of a subtotal along the rail, 0-100.

     The milestones are spaced EVENLY (each gets 1/n of the rail) regardless of how far
     apart their rupee values are, so the bar reads as even steps. The fill therefore has
     to be interpolated WITHIN the current segment — a plain subtotal/topTier percentage
     would leave the fill head short of (or past) a milestone at the moment it unlocks.
     snippets/wl-cart-rewards.liquid computes the same thing for the first paint; the two
     must stay in step. */
  function railPct(subtotal, tiers) {
    var n = tiers.length;
    if (!n) return 0;
    var seg = 100 / n;
    if (subtotal >= tiers[n - 1]) return 100;
    for (var i = 0; i < n; i++) {
      if (subtotal < tiers[i]) {
        var lo = i === 0 ? 0 : tiers[i - 1];
        var span = tiers[i] - lo;
        var frac = span > 0 ? (subtotal - lo) / span : 0;
        if (frac < 0) frac = 0;
        if (frac > 1) frac = 1;
        return (i + frac) * seg;
      }
    }
    return 100;
  }

  /* A confetti burst when a milestone is earned. The particles are parented to the
     drawer (or <body> on the cart page) rather than to the rewards module, because
     `.wl-rw` is overflow:hidden and clipped them inside the bar. They launch from the
     MIDDLE of the panel so the whole drawer celebrates, not just the strip. The layer
     is pointer-events:none and overflow:hidden, so it can never shift layout, add a
     scrollbar, or intercept a tap on checkout. */
  function celebrate(box) {
    var host = box.closest('#CartDrawer');
    var pinned = false;
    if (!host) { host = document.body; pinned = true; }

    var layer = host.querySelector('.wl-rw-sky');
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'wl-rw-sky' + (pinned ? ' wl-rw-sky--fixed' : '');
      layer.setAttribute('aria-hidden', 'true');
      host.appendChild(layer);
    }

    var sky = layer.getBoundingClientRect();
    if (!sky.width || !sky.height) return;
    /* Emitted along a horizontal BAND across the middle of the panel rather than from a
       single point — a point source fires one narrow fountain up the centre, whereas a
       band gives left / centre / right coverage on the way up, which is what reads as a
       celebration. Each particle still gets its own drift, rise and spin. */
    var bandLeft = sky.width * 0.08;
    var bandWidth = sky.width * 0.84;
    var bandY = sky.height * 0.46;

    var colours = ['#96274F', '#D2799B', '#B3822F', '#D9A441', '#2F8A54', '#7B2342', '#E7A6BE'];
    var frag = document.createDocumentFragment();
    var longest = 0;

    for (var i = 0; i < 44; i++) {
      var p = document.createElement('i');
      var shape = document.createElement('b');

      /* Spread the launch points evenly across the band, then jitter, so no gaps. */
      var originX = bandLeft + bandWidth * ((i + Math.random()) / 44);
      var originY = bandY + (Math.random() - 0.5) * sky.height * 0.08;

      var fx = (Math.random() * 2 - 1) * sky.width * 0.2;
      var py = -(originY * (0.6 + Math.random() * 0.45) + 40);
      var fy = sky.height - originY + 90;
      var dur = 1600 + Math.random() * 800;
      var delay = Math.random() * 220;
      if (dur + delay > longest) longest = dur + delay;

      p.style.left = originX.toFixed(1) + 'px';
      p.style.top = originY.toFixed(1) + 'px';
      p.style.setProperty('--fx', fx.toFixed(1) + 'px');
      p.style.setProperty('--py', py.toFixed(1) + 'px');
      p.style.setProperty('--fy', fy.toFixed(1) + 'px');
      p.style.setProperty('--rot', Math.round((Math.random() - 0.5) * 940) + 'deg');
      p.style.animationDuration = dur + 'ms';
      p.style.animationDelay = delay.toFixed(0) + 'ms';

      shape.style.background = colours[i % colours.length];
      shape.style.width = (5 + Math.round(Math.random() * 4)) + 'px';
      shape.style.height = (8 + Math.round(Math.random() * 7)) + 'px';
      if (i % 5 === 0) shape.style.borderRadius = '50%';
      shape.style.animationDuration = dur + 'ms';
      shape.style.animationDelay = delay.toFixed(0) + 'ms';

      p.appendChild(shape);
      frag.appendChild(p);
    }

    layer.appendChild(frag);
    clearTimeout(layer.__wlSweep);
    layer.__wlSweep = setTimeout(function () { layer.textContent = ''; }, longest + 250);
  }

  /* Called by cart-drawer.liquid after an authoritative region swap — that path
     repaints the bar from server markup and would otherwise skip the unlock moment. */
  window.wlApplyRewards = applyRewards;
  /* Exposed so the (non-flag-gated) drawer intro can fire the same confetti burst for
     the always-on "free shipping on prepaid" unlock. */
  window.wlRewardsCelebrate = celebrate;

  /* Line-level figures, also verbatim from the server's cart JSON. */
  function applyExactLines(cart) {
    var rows = rowsLive();
    if (!cart || !cart.items || rows.length !== cart.items.length) return false;
    for (var i = 0; i < rows.length; i++) {
      if (attrInt(rows[i], 'data-wl-vid') !== cart.items[i].variant_id) return false;
    }
    cart.items.forEach(function (it, i) {
      var row = rows[i];
      var input = qInput(row);
      if (input) { input.value = it.quantity; input.setAttribute('data-wl-prev', String(it.quantity)); }
      row.setAttribute('data-wl-unit-final', String(it.final_price));
      row.setAttribute('data-wl-var-price', String(it.original_price));
      var finalEl = row.querySelector('.hdt-mini-cart__price hdt-price .hdt-money, .hdt-mini-cart__price .hdt-price .hdt-money');
      if (finalEl) finalEl.textContent = fmtCents(it.final_price);   /* UNIT price, exactly as Liquid renders it */
      syncQtyButtons(row);
    });
    return true;
  }

  /* One request → exact figures everywhere, or an authoritative full render.
     Queued: a variant rebuild empties the cart between its clear and its add, and a
     quantity change landing in that window would target a line that does not exist. */
  function commitExact(url, body, opts) {
    opts = opts || {};
    beginBusy();
    return queueCartWork(function () { return postJSON(url, withMoney(body)); }).then(function (data) {
      var moneyEl = parseMoneyEl(data);
      var okLines = opts.skipLines ? true : applyExactLines(data);
      var okMoney = okLines && applyExactMoney(moneyEl, opts);
      if (!okLines || !okMoney) {
        /* structural change (a bill row appears/disappears) — take the authoritative
           render, but keep the carousel node so it cannot re-init and flicker */
        if (api() && api().reload) return api().reload({ keepRecs: true }).then(syncAllQtyButtons).then(function () { endBusy(); return data; });
      }
      endBusy();
      return data;
    }).catch(function (e) { endBusy(); throw e; });
  }

  /* Money figures cannot be predicted (everything is server-exact), so there is always a
     round trip between the click and the new price. Without any signal the figures just
     sit at the old value and then snap, which reads as "nothing happened, then it
     lagged". These two classes make the wait legible: the affected figures soften while
     the server is authoritative-in-flight, then land with a brief lift. No invented
     number is ever shown. */
  var busyDepth = 0;
  function beginBusy() {
    busyDepth++;
    var d = dlg(); if (d) d.classList.add('wl-opt-busy');
    var p = document.getElementById('hdt-page-cart'); if (p) p.classList.add('wl-opt-busy');
  }
  function endBusy() {
    if (busyDepth > 0) busyDepth--;
    if (busyDepth) return;
    [dlg(), document.getElementById('hdt-page-cart')].forEach(function (el) {
      if (!el) return;
      el.classList.remove('wl-opt-busy');
      if (reduceMotion()) return;
      el.classList.add('wl-opt-settled');
      clearTimeout(el.__wlSettle);
      el.__wlSettle = setTimeout(function () { el.classList.remove('wl-opt-settled'); }, 620);
    });
  }

  /* setAttribute() fires a MutationRecord even when the value is IDENTICAL, which wakes
     every observer watching the drawer and re-invalidates style for that element. These
     controls are re-synced after every render, so writing unconditionally produced a
     burst of no-op attribute writes on each one. Write only on a real change. */
  function attrIf(el, name, val) { if (el.getAttribute(name) !== val) el.setAttribute(name, val); }

  /* Reflect min/max limits on the +/- buttons so a dead control LOOKS dead.
     NOTE: the server already renders this exact state (see snippets/item-cart.liquid), so
     on a fresh render this pass should find nothing to change. */
  function syncQtyButtons(row) {
    var input = qInput(row); if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 0;
    var max = parseInt(input.getAttribute('data-max'), 10); if (isNaN(max)) max = 9999;
    var q = parseInt(input.value, 10) || 0;
    var dec = row.querySelector('.hdt-quantity__button.is--minus, [name="minus"]');
    var inc = row.querySelector('.hdt-quantity__button.is--plus, [name="plus"]');
    if (dec) {
      var decOff = q <= min;
      if (dec.disabled !== decOff) dec.disabled = decOff;
      attrIf(dec, 'aria-disabled', String(decOff));
    }
    if (inc) {
      var incOff = q >= max;
      if (inc.disabled !== incOff) inc.disabled = incOff;
      attrIf(inc, 'aria-disabled', String(incOff));
      attrIf(inc, 'title', incOff ? 'No more stock available' : '');
    }
  }
  function syncAllQtyButtons() { rowsAll().forEach(syncQtyButtons); pruneRecs(); }
  /* "You may also love" must never offer something already in the bag. The Liquid loop
     tries this with `line_items_for`, but that is unreliable inside the Section Rendering
     response that <product-recommendations> fetches, and we deliberately keep the carousel
     node alive across cart updates so it cannot re-init and flicker - so it goes stale.
     Cart state is always current here, so prune from the client after every mutation.
     Hidden rather than removed, so a card comes back if its line is deleted. */
  function pruneRecs() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var inCart = {};
    rowsAll().forEach(function (r) {
      var v = r.getAttribute('data-wl-vid');
      if (v) inCart[String(v)] = 1;
    });
    drawer.querySelectorAll('[data-wl-rec-add]').forEach(function (btn) {
      var card = btn.closest('.hdt-minicart-recommendations__item') || btn.closest('.hdt-slider__slide');
      if (!card) return;
      var vid = btn.getAttribute('data-vid') || btn.getAttribute('data-variant-id');
      var hide = !!(vid && inCart[String(vid)]);
      if (hide === card.hasAttribute('data-wl-rec-hidden')) return;
      if (hide) { card.setAttribute('data-wl-rec-hidden', ''); card.style.display = 'none'; }
      else { card.removeAttribute('data-wl-rec-hidden'); card.style.display = ''; }
    });
  }

  /* Shopify RE-INDEXES the remaining cart lines after a removal: delete line 2 of 3
     and the old line 3 becomes line 2. The DOM keeps the original indices, so every
     later quantity/size action on a surviving row would target the WRONG cart line.
     The full drawer re-render used to hide this; the cheap path must do it itself. */
  function renumberLines() {
    rowsLive().forEach(function (row, i) {
      var n = String(i + 1);
      var input = qInput(row); if (input) input.setAttribute('data-index', n);
      [].slice.call(row.querySelectorAll('[data-line]')).forEach(function (el) { el.setAttribute('data-line', n); });
      var rem = row.querySelector('.hdt-mini-cart__remove');
      if (rem && rem.getAttribute('href')) rem.setAttribute('href', rem.getAttribute('href').replace(/line=\d+/, 'line=' + n));
    });
  }

  /* Removing a row used to request the ENTIRE drawer section (~148KB, ~1.1s). That
     left a visible gap where the row had been while the old total sat there stale,
     and - because the returned markup replaces the drawer - it also destroyed the
     "You may also love" block, which then re-fetched itself TWICE (~322KB) and
     visibly grew then shrank. The tiny money section (~5KB) carries exactly the same
     authoritative figures; the only things the big render really provided were the
     row's disappearance and the re-indexing, both done directly here.
     A full render is still taken whenever the structure genuinely changes. */
  function commitRemoval(line, row, stillCurrent) {
    row.setAttribute('data-wl-gone', '');
    animateOut(row);
    /* Detach as soon as the collapse finishes - NOT when the server replies. A row
       collapsed to height 0 still contributes the list's flex `gap`, so waiting for
       the response left a ~38px hole sitting under the cursor for most of a second.
       rowsLive() already ignores it, and any failure path re-renders anyway. */
    var ref = lineRef(row, line);
    /* rowsLive() already excludes this row (data-wl-gone was set above), so an empty
       result means this is the last line and the cart is about to be empty - which is
       the one case that needs the server's empty-state markup. Ask for it now instead
       of paying a second round trip once the response lands. */
    var emptiesCart = rowsLive().length === 0;
    dropRow(row);
    return queueCartWork(function () {
      var body = { id: ref.id, line: ref.line, quantity: 0 };
      return postJSON('/cart/change.js', emptiesCart ? withMoneyAndDrawer(body) : withMoney(body));
    })
      .catch(function (err) {
        /* Removing a line that is ALREADY gone is not a failure - the desired end state
           is exactly what the server reports. Shopify answers "no valid id or line
           parameter" (400/422) in that case. This happens when an authoritative
           re-render replaced the row nodes, wiping the in-flight guard, and a queued
           click for the old node still fires. Treat it as done and reconcile from the
           server rather than showing the shopper a scary failure. */
        var st = err && err.res && err.res.status;
        if (st !== 400 && st !== 422) throw err;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { if (api() && api().reload) api().reload({ keepRecs: true }); return c; });
      })
      .then(function (data) {
        /* The header badge is only ever written by applyExactMoney, and NEITHER the
           empty-cart path nor the fallback-render path below reaches it - so removing
           the last line left `<hdt-cart-count>` stuck on its old number (the drawer's
           own data-count did update, which is why this only showed in the header).
           The money section rides along with this request, so take the authoritative
           VISIBLE count from it here, before any branching. */
        var countEl = parseMoneyEl(data);
        if (countEl) syncCount(countEl.getAttribute('data-item-count'));
        if (stillCurrent && !stillCurrent()) return data;
        /* An empty cart needs Liquid's empty-state markup, which the money section
           cannot provide - but it came back with THIS response (see withMoneyAndDrawer),
           so apply it immediately rather than fetching the section all over again. */
        if (!data.item_count || !data.items || !data.items.length) {
          syncCount(0);
          if (!applyFrom(data)) { if (api() && api().reload) api().reload(); }
          return data;
        }
        var okLines = applyExactLines(data);
        var okMoney = okLines && applyExactMoney(parseMoneyEl(data));
        if (!okLines || !okMoney) {
          if (api() && api().reload) api().reload({ keepRecs: true }).then(syncAllQtyButtons);
          return data;
        }
        renumberLines();
        syncAllQtyButtons();
        return data;
      });
  }

  /* A full server re-render is only needed when the drawer's STRUCTURE changes.
     Money never needs one: exact figures arrive with every mutation. */
  var reconcileTimer;
  function scheduleReconcile() { /* retained as a no-op hook; exact money makes it unnecessary */ }

  var qLast = {};
  /* Debounce/sequence bookkeeping is keyed by the row's STABLE key, not its positional
     line. Keyed by line, a removal re-indexes the cart and two different products can
     collide in the same bucket - one row's in-flight sequence then cancels another's. */
  function qKeyOf(row, line) { return (row && row.getAttribute && row.getAttribute('data-wl-vid')) || ('L' + line); }
  function scheduleQty(row, immediate) {
    var line = lineOf(row); if (!line) return;
    /* A row already on its way out must not accept further quantity work. */
    if (row.__wlRemoving) return;
    var k = qKeyOf(row, line);
    clearTimeout(qTimer[k]);
    if (immediate) { qLast[k] = Date.now(); commitQty(row, line, k); return; }
    /* LEADING EDGE: the first click of a burst goes straight out. The old trailing-only
       debounce charged every single click 120ms of dead time for a coalescing benefit
       that only applies when clicks land <120ms apart, which is rare. Rapid follow-up
       clicks still coalesce, and queueCartWork + the key-addressed request make
       overlapping mutations safe and ordered. */
    var now = Date.now();
    if (now - (qLast[k] || 0) > 400) { qLast[k] = now; commitQty(row, line, k); return; }
    qTimer[k] = setTimeout(function () { qLast[k] = Date.now(); commitQty(row, line, k); }, 140);
  }
  function commitQty(row, line, k) {
    k = k || qKeyOf(row, line);
    var input = qInput(row); if (!input) { row.classList.remove('wl-opt-pending'); return; }
    var q = parseInt(input.value, 10); if (isNaN(q) || q < 0) q = 0;
    var removing = q === 0;
    /* The row may already be gone - its removal is in flight, or it has been detached.
       Sending another change for it earns a 400/422 from Shopify (the line no longer
       exists) and pops a spurious failure toast, so drop it here instead. */
    if (row.__wlRemoving) return;
    if (!removing && (!row.isConnected || row.hasAttribute('data-wl-gone'))) return;
    if (removing) row.__wlRemoving = true;
    var seq = (qSeq[k] = (qSeq[k] || 0) + 1);
    var guard = setTimeout(function () { if (seq === qSeq[k]) { row.classList.remove('wl-opt-pending'); fail(); } }, 9000);
    if (removing) {
      commitRemoval(line, row, function () { return seq === qSeq[k]; })
        .then(function () { clearTimeout(guard); row.classList.remove('wl-opt-pending'); })
        .catch(function () { clearTimeout(guard); row.classList.remove('wl-opt-pending'); if (seq === qSeq[k]) fail(); });
      return;
    }
    commitExact('/cart/change.js', (function () { var r = lineRef(row, line); return { id: r.id, line: r.line, quantity: q }; })())
      .then(function () { clearTimeout(guard); row.classList.remove('wl-opt-pending'); })
      .catch(function () { clearTimeout(guard); row.classList.remove('wl-opt-pending'); if (seq === qSeq[k]) fail(); });
  }
  function onQtyBtn(btn) {
    if (btn.disabled || btn.hasAttribute('disabled')) return;
    var row = rowOf(btn); var input = qInput(row); if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 0;
    var max = parseInt(input.getAttribute('data-max'), 10); if (isNaN(max)) max = 9999;
    var prev = parseInt(input.value, 10) || 0;
    var isPlus = btn.classList.contains('is--plus') || btn.name === 'plus';
    var q = isPlus ? Math.min(max, prev + 1) : Math.max(min, prev - 1);
    /* Already clamped at the stock limit / minimum: nothing changed, so don't spend a
       request or a re-render on it. */
    if (q === prev) { syncQtyButtons(row); return; }
    /* Only the control's own state echoes immediately - never a money figure. */
    input.value = q;
    syncQtyButtons(row);
    if (q === 0) { row.setAttribute('data-wl-gone', ''); animateOut(row); scheduleQty(row, true); return; }
    scheduleQty(row);
  }
  function onQtyInputChange(input) {
    var row = rowOf(input); if (!row) return;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    var max = parseInt(input.getAttribute('data-max'), 10); if (isNaN(max)) max = 9999;
    var typed = parseInt(input.value, 10);
    var q = typed; if (isNaN(q) || q < min) q = min; if (q > max) { q = max; notice('Only ' + max + ' available in this size'); }
    input.value = q;
    input.setAttribute('data-wl-prev', String(q));
    syncQtyButtons(row);
    if (q === 0) { row.setAttribute('data-wl-gone', ''); animateOut(row); scheduleQty(row, true); return; }
    scheduleQty(row);
  }

  /* ================= SIZE (optimistic label + background rebuild) ========= */
  var vSeq = 0;
  function closeSizeMenus() {
    var d = dlg(); if (!d) return;
    d.querySelectorAll('.wl-size__menu.is-portal').forEach(function (menu) {
      menu.classList.remove('is-portal');
      menu.style.position = menu.style.left = menu.style.top = menu.style.minWidth = '';
      if (menu._wlHome) menu._wlHome.appendChild(menu);
    });
    d.querySelectorAll('.wl-size.is-open').forEach(function (x) {
      x.classList.remove('is-open');
      var t = x.querySelector('[data-wl-size-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  function rowByLine(line) {
    var rows = lineRows();
    for (var i = 0; i < rows.length; i++) { var sz = rows[i].querySelector('.wl-size'); if (sz && parseInt(sz.getAttribute('data-line'), 10) === line) return rows[i]; }
    return rows[line - 1] || null;
  }
  /* Warm the cart JSON the moment a size menu is opened. Swapping a variant needs the
     current cart to rebuild it, and fetching that only after the shopper picks a size
     put ~480ms of pure latency in front of every size change.
     `cartEpoch` invalidates the warm copy the instant anything mutates the cart - a
     stale read here is catastrophic, because the rebuild below clears the cart first. */
  var cartWarm = null, cartEpoch = 0;
  function invalidateCart() { cartEpoch++; cartWarm = null; }
  function readCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function warmCart() {
    var epoch = cartEpoch;
    var p = readCart();
    cartWarm = { epoch: epoch, p: p };
    return p;
  }
  function freshCart() {
    if (cartWarm && cartWarm.epoch === cartEpoch) { var p = cartWarm.p; cartWarm = null; return p; }
    cartWarm = null;
    return readCart();
  }

  /* ---- Destructive rebuild, serialised -----------------------------------------
     Shopify cannot change a line's variant in place, so a size swap is clear -> add.
     That is destructive and MUST NOT overlap another one. Changing size twice quickly
     used to interleave: the second swap read the cart while the first had it cleared,
     built an empty payload, cleared again and POSTed `items: []` -> HTTP 400 -> the
     shopper's cart was WIPED while the header badge still showed a count.
     Everything below is now queued, the cart is always re-read inside the queue, an
     empty payload is refused outright, and a failed add restores the snapshot. */
  var cartQueue = Promise.resolve();
  function queueCartWork(fn) {
    var run = cartQueue.then(fn, fn);
    cartQueue = run.then(function () {}, function () {});
    return run;
  }
  /* Published for wl-free-gift.js, which is NOT flag-gated and therefore cannot import
     anything from this file. It is the other cart writer, so it must share THIS queue
     (and drop THIS warm copy) whenever the optimizer is running, or a gift write could
     land between a size swap's clear and add. With the optimizer off nothing publishes
     these and that module falls back to serialising only its own work, which is correct
     because it is then the only writer. */
  window.wlCartQueue = queueCartWork;
  window.wlCartInvalidate = invalidateCart;

  /* ==== AUTOMATIC FREE GIFT — MOVED OUT ==========================================
     It now lives in assets/wl-free-gift.js. It was here, behind `?wlopt=0`, which meant
     a visitor who used that PERFORMANCE escape hatch silently lost a PRODUCT feature:
     the cart qualified, the discount existed, and no gift arrived. It watches the /cart/
     endpoints itself, so nothing in this file needs to call it. See wlCartQueue above
     for how the two writers stay serialised. */

  function lineToAddItem(it) {
    var o = { id: it.variant_id, quantity: it.quantity };
    if (it.properties && Object.keys(it.properties).length) o.properties = it.properties;
    if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) o.selling_plan = it.selling_plan_allocation.selling_plan.id;
    return o;
  }
  /* mapItems(cart) -> array in CART order. Resolves with the /cart/add.js response. */
  function rebuildCart(mapItems) {
    return queueCartWork(function () {
      return freshCart().then(function (cart) {
        var snapshot = (cart.items || []).map(lineToAddItem);
        var items = mapItems(cart);
        /* never clear a cart we cannot refill */
        if (!items || !items.length) throw new Error('wl-empty-rebuild');
        invalidateCart();
        return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
          .then(function () { return postJSON('/cart/add.js', withMoney({ items: items.slice().reverse() })); })
          .catch(function (err) {
            /* the cart is empty at this point - put it back exactly as it was */
            if (!snapshot.length) throw err;
            return postJSON('/cart/add.js', { items: snapshot.slice().reverse() })
              .then(function () { invalidateCart(); throw err; },
                    function () { invalidateCart(); throw err; });
          });
      });
    });
  }

  function onSizeOpt(opt) {
    if (opt.disabled || opt.classList.contains('is-out') || opt.classList.contains('is-inbag') || opt.classList.contains('is-sel')) { closeSizeMenus(); return; }
    var menu = opt.closest('.wl-size__menu');
    var sizeBox = opt.closest('.wl-size');
    var line = menu && menu._wlLine != null ? menu._wlLine : (sizeBox ? parseInt(sizeBox.getAttribute('data-line'), 10) : null);
    var row = rowByLine(line);
    if (!row) { closeSizeMenus(); return; }
    var qty = rowQty(row) || (menu && menu._wlQty) || 1;
    var vid = parseInt(opt.getAttribute('data-vid'), 10);
    var label = (opt.textContent || '').trim();
    var vmax = parseInt(opt.getAttribute('data-max'), 10); if (isNaN(vmax) || vmax < 0) vmax = 999;
    var vprice = attrInt(opt, 'data-price');
    var vcmp = attrInt(opt, 'data-cmp');
    if (!line || !vid) { closeSizeMenus(); return; }

    /* ---- INVENTORY GUARD: never let a size switch over-commit real stock -------
       the target size may already sit on another line, so the switch must respect
       (variant stock − quantity already in the bag on other lines). */
    var existing = 0;
    rowsLive().forEach(function (r) {
      if (r === row) return;
      if (String(attrInt(r, 'data-wl-vid')) === String(vid)) existing += rowQty(r);
    });
    var allowed = vmax - existing;
    if (allowed <= 0) {
      closeSizeMenus();
      notice(existing > 0 ? 'That size is already in your bag' : 'That size is out of stock');
      return;
    }
    var newQty = qty;
    if (newQty > allowed) { newQty = allowed; notice('Only ' + allowed + ' left in that size'); }

    closeSizeMenus();

    /* ---- Echo ONLY the control state (chosen size + quantity cap). No price or
       total is touched here: every money figure comes from the server below, so a
       size whose price differs can never be shown wrong. ---- */
    var prevState = {
      vid: attrInt(row, 'data-wl-vid'), unitFinal: attrInt(row, 'data-wl-unit-final'),
      varPrice: attrInt(row, 'data-wl-var-price'), varCmp: attrInt(row, 'data-wl-var-cmp'),
      max: attrInt(row, 'data-wl-max'), qty: qty
    };
    row.setAttribute('data-wl-vid', String(vid));
    row.setAttribute('data-wl-var-cmp', String(vcmp));
    row.setAttribute('data-wl-max', String(vmax));
    var input = qInput(row);
    if (input) { input.value = newQty; input.setAttribute('data-wl-prev', String(newQty)); input.setAttribute('data-max', String(vmax)); input.setAttribute('max', String(vmax)); }
    var tog = row.querySelector('[data-wl-size-toggle] span'); if (tog) tog.textContent = label;
    if (sizeBox) { sizeBox.setAttribute('data-cur', String(vid)); sizeBox.setAttribute('data-qty', String(newQty)); }
    row.querySelectorAll('.wl-size__opt').forEach(function (o) { o.classList.toggle('is-sel', String(o.getAttribute('data-vid')) === String(vid)); });
    var finalEl = row.querySelector('.hdt-mini-cart__price hdt-price .hdt-money, .hdt-mini-cart__price .hdt-price .hdt-money');
    var cmpEl = row.querySelector('.hdt-mini-cart__price hdt-compare-at-price .hdt-money, .hdt-mini-cart__price .hdt-compare-at-price .hdt-money');
    var cmpWrap = row.querySelector('.hdt-mini-cart__price hdt-compare-at-price, .hdt-mini-cart__price .hdt-compare-at-price');
    /* Prices are NOT touched here - the server's figures arrive below. */
    syncQtyButtons(row);

    var seq = ++vSeq;
    var guard = setTimeout(function () { if (seq === vSeq) fail(); }, 12000);

    /* Rebuild preserves line order + properties + selling plans, and is serialised so
       two quick size changes can never interleave and wipe the cart. */
    rebuildCart(function (cart) {
      /* QUANTITY MUST COME FROM THE SERVER, NEVER FROM THE DOM INPUT.
         The theme clamps that input to the variant's CURRENT max, so a cart legitimately
         holding 2 units of a variant whose stock has since dropped to 1 renders "1".
         Rebuilding from the DOM therefore destroyed a unit — and its money — on every
         size swap (measured: 2 units / ₹3,598.20 became 1 unit / ₹1,799.10, silently).
         `cart` here is a fresh server read, so it is the only trustworthy source; the
         target size's own stock is still respected through `allowed`. */
      var srvLine = cart.items[line - 1];
      var baseQty = (srvLine && srvLine.quantity) || newQty;
      var want = Math.min(baseQty, allowed);
      if (want < baseQty) notice('Only ' + want + ' left in that size');
      return cart.items.map(function (it, idx) {
        var nid = (idx === line - 1) ? vid : it.variant_id;
        var o = { id: nid, quantity: (idx === line - 1) ? want : it.quantity };
        if (it.properties && Object.keys(it.properties).length) o.properties = it.properties;
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) o.selling_plan = it.selling_plan_allocation.selling_plan.id;
        return o;
      });
    }).then(function (data) {
      clearTimeout(guard);
      if (seq !== vSeq) return;
      /* After a clear the add response IS the whole cart, and it carries final_price /
         original_price / quantity per line - so no follow-up /cart.js is needed. It
         comes back in REQUEST order, which was reversed, so reverse it back. The
         variant-id check inside applyExactLines verifies that assumption and forces an
         authoritative render if it ever stops holding. */
      var rebuilt = (data && data.items) ? { items: data.items.slice().reverse() } : null;
      var ok = rebuilt && applyExactLines(rebuilt) && applyExactMoney(parseMoneyEl(data));
      if (!ok && api() && api().reload) return api().reload({ keepRecs: true }).then(syncAllQtyButtons);
      syncAllQtyButtons();
    }).catch(function () {
      clearTimeout(guard);
      if (seq !== vSeq) return;
      /* restore the row to its pre-click state, then resync from the server */
      row.setAttribute('data-wl-vid', String(prevState.vid));
      row.setAttribute('data-wl-unit-final', String(prevState.unitFinal));
      row.setAttribute('data-wl-var-price', String(prevState.varPrice));
      row.setAttribute('data-wl-var-cmp', String(prevState.varCmp));
      row.setAttribute('data-wl-max', String(prevState.max));
      fail();
    });
  }

  /* ================= WISHLIST heart (stash + remove, single trip) ========= */
  function stashWished(li, btn) {
    var pid = null;
    try {
      pid = btn.getAttribute('data-id');
      var szBox = li.querySelector('.wl-size'); var vid = szBox ? szBox.getAttribute('data-cur') : null;
      var a = li.querySelector('.hdt-mini-cart__title'); var title = a ? a.textContent.trim() : ''; var url = a ? (a.getAttribute('href') || '') : '';
      var img = li.querySelector('img'); var isrc = img ? (img.currentSrc || img.getAttribute('src') || '') : '';
      var p = li.querySelector('.hdt-mini-cart__price'); var price = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
      /* Carry the EXACT cents so the wishlisted card can render the same
         compare-at/sale markup as a native recommendation card. The text above
         includes the theme's screen-reader labels ("Regular price ... Sale
         price ..."), which used to be printed verbatim onto the card. */
      var nowC = attrInt(li, 'data-wl-unit-final');
      var wasC = attrInt(li, 'data-wl-unit-cmp');
      var arr = []; try { arr = JSON.parse(sessionStorage.getItem('wl:cart-wished') || '[]'); } catch (_) {}
      if (!(vid && arr.some(function (z) { return String(z.vid) === String(vid); }))) {
        arr.push({ vid: vid, pid: pid, title: title, url: url, img: isrc, price: price, now: nowC, was: wasC });
        sessionStorage.setItem('wl:cart-wished', JSON.stringify(arr));
      }
    } catch (e) {}
    /* PERSIST to the REAL wishlist. The drawer previously only kept a session note, so
       the item left the cart and was lost on navigation, while the cart page's
       "move to wishlist" did save it - the two surfaces disagreed. */
    try {
      if (pid) {
        var key = 'theme4:wishlist:id';
        var list = (localStorage.getItem(key) || '').split(',').filter(Boolean);
        if (list.indexOf(String(pid)) === -1) {
          list.unshift(String(pid));
          localStorage.setItem(key, list.toString());
          document.dispatchEvent(new CustomEvent('theme4:wishlist:update', { bubbles: true, detail: list }));
        }
      }
    } catch (e) {}
  }
  var wSeq = 0;
  function onWishHeart(btn) {
    if (!(btn.matches && btn.matches('hdt-wishlist'))) return false; /* app-mode wishlist → let native handle */
    var li = btn.closest('hdt-line-item') || btn.closest('.hdt-cart-item'); if (!li) return false;
    var input = li.querySelector('input[name="updates[]"]');
    var line = input ? parseInt(input.getAttribute('data-index'), 10) : null;
    if (!line) { var rem = li.querySelector('.hdt-mini-cart__remove'); var m = rem && (rem.getAttribute('href') || '').match(/line=(\d+)/); line = m ? parseInt(m[1], 10) : null; }
    if (!line) return false;
    var pid = btn.getAttribute('data-id');
    var seq = (wSeq = wSeq + 1);
    /* ORDER MATTERS. stashWished() writes localStorage, dispatches the wishlist sync
       event and re-reads the row — measured at ~211ms before the cart request even
       began, and it grows with cart size because more rows get re-scanned. None of that
       needs to block the network, so the removal is kicked off FIRST and the bookkeeping
       runs while the request is in flight.
       `li` is still attached at this point: commitRemoval only detaches the row on its
       transitionend (~340ms later), so stashWished can still read the row's data. */
    var pending = commitRemoval(line, li, function () { return seq === wSeq; });
    /* Let the collapse state paint before localStorage writes, wishlist sync listeners
       and recommendation construction run. A nested rAF guarantees one painted frame;
       the row remains attached until its 340ms height transition ends, so its server
       data is still available and the wished slide still lands inside the browser's
       500ms input window. */
    var wishFeedbackDone = false;
    var commitWishFeedback = function () {
      if (wishFeedbackDone || seq !== wSeq || !li.isConnected) return;
      wishFeedbackDone = true;
      stashWished(li, btn);
      showWished(pid);
    };
    requestAnimationFrame(function () {
      requestAnimationFrame(commitWishFeedback);
    });
    /* Background tabs may suspend rAF entirely. Keep move-to-wishlist functional
       there while remaining inside the browser's 500ms input window. */
    setTimeout(commitWishFeedback, 100);
    /* Insert the wished slide before the request settles, not in pending.then(). The insert PREPENDS a card,
       which pushes every existing slide sideways; run after the ~790ms round trip that
       shift falls OUTSIDE the 500ms input window and counts against CLS - measured
       0.0479 at 792ms on .hdt-minicart-recommendations__item with movedY 0, i.e. purely
       horizontal, and it was the drawer's single worst layout shift (0.070 total).
       stashWished() has already written the entry wlAllWished() reads, so the card can
       be built immediately; doing it in the same input window makes the browser excuse
       the shift AND gives the shopper instant feedback instead of a 0.8s wait.
       If the removal fails, fail() reloads the drawer, which clears this optimistic card. */
    pending
      .catch(function () { if (seq === wSeq) fail(); });
    return true;
  }

  /* ================= COUPON (apply / remove) ==============================
     The native component POSTs /cart/update.js and then fires a full drawer
     RELOAD, so a code took ~3s to show. We do the same POST but ask for the
     drawer section in the SAME request and apply it directly - one round trip.
     Removal is mathematically predictable (total goes back up by exactly the
     discount) so, when a single code is applied, the figures move instantly. */
  function discountCodesApplied() {
    var d = dlg(); if (!d) return [];
    return [].slice.call(d.querySelectorAll('.hdt-discount-remove[data-discount-code], .wl-coupon-x[data-discount-code]'))
      .map(function (b) { return (b.getAttribute('data-discount-code') || '').trim(); })
      .filter(Boolean)
      .filter(function (v, i, a) { return a.indexOf(v) === i; });
  }
  function postDiscount(codeString) {
    return postJSON('/cart/update.js', withSections({ discount: codeString }));
  }
  function couponBusy(on) {
    var d = dlg(); if (!d) return;
    var btn = d.querySelector('[data-cart-discount-apply]');
    if (btn) btn.classList.toggle('hdt-btn-loading', !!on);
  }
  function onCouponApply(btn) {
    var d = dlg(); if (!d) return;
    var input = d.querySelector('[data-cart-discount-input]'); if (!input) return;
    var typed = (input.value || '').trim();
    if (!typed) return;
    /* mirror the native multi-code behaviour exactly */
    var existing = (input.getAttribute('data-value') || '').trim();
    var codeString = existing ? (typed + ',' + existing) : typed;
    var err = d.querySelector('[data-cart-discount-error]');
    couponBusy(true);
    postDiscount(codeString)
      .then(function (data) {
        couponBusy(false);
        var dc = data && data.discount_codes;
        var applicable = dc && dc.length && dc.some(function (c) { return c.code && c.code.toUpperCase() === typed.toUpperCase() && c.applicable; });
        if (!applicable) {
          /* Nothing was applied, so the cart is unchanged - do NOT re-render. A render
             here would replace the error element and the shopper would see no feedback
             at all. Money on screen is already the server's current truth. */
          var errNow = d.querySelector('[data-cart-discount-error]');
          if (errNow) {
            if (!errNow.textContent.trim()) errNow.textContent = 'Enter a valid discount code';
            errNow.style.display = 'block';
          }
          if (input) input.value = '';
          var miniNow = d.querySelector('[data-cart-mini-discount-apply]'); if (miniNow) miniNow.style.display = 'none';
          return;
        }
        applyFrom(data, { keepRecs: true });
        syncAllQtyButtons();
        var clearErr = function () {
          var d2 = dlg(); if (!d2) return;
          var e2 = d2.querySelector('[data-cart-discount-error]'); if (e2) e2.style.display = 'none';
        };
        clearErr();
        [300, 900].forEach(function (ms) { setTimeout(clearErr, ms); });
      })
      .catch(function () { couponBusy(false); if (err) { err.style.display = 'block'; } fail(); });
  }
  function onCouponRemove(btn) {
    var d = dlg(); if (!d) return;
    var code = (btn.getAttribute('data-discount-code') || '').trim(); if (!code) return;
    var input = d.querySelector('[data-cart-discount-input]');
    var list = [];
    if (input && input.hasAttribute('data-value')) {
      list = (input.getAttribute('data-value') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    if (!list.length) list = discountCodesApplied();
    var remaining = list.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });

    /* The chip is a control, not a money figure, so it can leave immediately; every
       amount still comes from the server response below. */
    var chip = btn.closest('.wl-coupon-chip, .hdt-discounts__discount, .hdt-discount-item');
    if (chip) chip.style.display = 'none';
    /* ...but hiding the chip alone left the cell EMPTY until the server render landed:
       `.hdt-cart-coupon.is-applied .wl-ctrig{display:none}` keeps the "Apply coupon"
       trigger hidden while that class is on. Measured a 1192ms blank box (chip gone at
       129ms, trigger back at 1438ms) which read as a flicker. Drop the class now so the
       trigger takes the chip's place in the same frame. Only when the LAST code goes:
       with another code still applied the cell must keep showing its chip. */
    var couponCell = btn.closest('.hdt-cart-coupon');
    var unapplied = false;
    if (couponCell && !remaining.length && couponCell.classList.contains('is-applied')) {
      couponCell.classList.remove('is-applied');
      couponCell.classList.add('wl-cc-collapsing');
      unapplied = true;
    }
    couponBusy(true);
    postDiscount(remaining.join(','))
      .then(function (data) {
        couponBusy(false);
        applyFrom(data, { keepRecs: true });
        syncAllQtyButtons();
      })
      .catch(function () {
        couponBusy(false);
        if (chip) chip.style.display = '';
        if (unapplied) { couponCell.classList.add('is-applied'); couponCell.classList.remove('wl-cc-collapsing'); }
        fail();
      });
  }

  /* ---------------- programmatic coupon entry point ----------------
     The document click listener bails on `e.isTrusted === false` (it must: the drawer
     fires SYNTHETIC heart clicks after every render, and treating those as user intent
     removed cart lines in a feedback loop). That guard is global, so any UI that drives
     the coupon field with `btn.click()` — the coupon sheet does exactly this — silently
     fell through to the THEME's native handler: a full drawer reload that destroys and
     rebuilds the "You may also love" carousel and costs several seconds.

     Exposing the handlers directly gives such callers the optimized path without
     weakening the isTrusted guard. When the optimizer is disabled (?wlopt=0) this object
     does not exist, and callers fall back to clicking the native button, which is the
     correct behaviour for that mode. */
  window.wlCartOptAPI = window.wlCartOptAPI || {};
  window.wlCartOptAPI.applyCoupon = function (code) {
    var d = dlg(); if (!d) return false;
    code = String(code || '').trim(); if (!code) return false;
    var input = d.querySelector('[data-cart-discount-input]');
    var btn = d.querySelector('[data-cart-discount-apply]');
    if (!input || !btn) return false;
    input.value = code;
    onCouponApply(btn);
    return true;
  };
  window.wlCartOptAPI.removeCoupon = function (code) {
    var d = dlg(); if (!d) return false;
    code = String(code || '').trim(); if (!code) return false;
    var btns = d.querySelectorAll('[data-discount-code]');
    for (var i = 0; i < btns.length; i++) {
      if (String(btns[i].getAttribute('data-discount-code') || '').toUpperCase() === code.toUpperCase()) {
        onCouponRemove(btns[i]);
        return true;
      }
    }
    return false;
  };

  /* ================= ADD from "You may also love" =========================
     The drawer's own handler did /cart/add.js then a FULL page reload+swap. Even the
     later keepRecs swap re-ATTACHED the carousel node, which re-initialised its slider:
     measured the carousel snapping back to slide 1 (translate -440 -> 0), its dots torn
     down and rebuilt, its slides replaced twice, its height twitching 154->148->154 and
     a wasted ~165KB re-fetch. So we no longer swap the drawer at all on an add - just
     insert the one new row and write the server's figures. The recommendations block is
     never touched, so it cannot flicker; it rebuilds naturally on the next drawer open. */
  /* Insert the newly added line using the SERVER's own markup for it - no placeholder,
     no invented values. Returns {added:node} or false so the caller can fall back to an
     authoritative render when anything does not line up. */
  function insertAddedRow(data, vid) {
    var html = data && data.sections && data.sections[NEWLINE_SID];
    var d = dlg(); if (!html || !d) return false;
    var doc; try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return false; }
    var root = doc.getElementById('wl-cart-newline'); if (!root) return false;
    var fresh = root.querySelector('hdt-line-item'); if (!fresh) return false;
    /* the newest line must be the variant we just added, or our prepend assumption
       no longer holds and the drawer must be rendered properly instead */
    if (attrInt(fresh, 'data-wl-vid') !== vid) return false;
    var live = rowsLive();
    if (!live.length) return false;                    /* empty cart needs the real render */
    var expected = parseInt(root.getAttribute('data-line-count'), 10);
    if (isNaN(expected) || expected !== live.length + 1) return false;
    var parent = live[0].parentNode; if (!parent) return false;
    var node = document.importNode(fresh, true);
    parent.insertBefore(node, live[0]);
    renumberLines();
    return { added: node };
  }
  /* Adding a variant already in the cart just increments that line - no new card. The
     add response carries that line's server quantity and unit price, so no markup is
     needed at all. */
  function bumpRowFromResponse(data, vid) {
    var it = null;
    if (data && data.items && data.items.length) {
      it = data.items.filter(function (x) { return x.variant_id === vid; })[0];
    } else if (data && data.variant_id === vid) { it = data; }
    if (!it) return false;
    var rows = rowsLive();
    for (var i = 0; i < rows.length; i++) {
      if (attrInt(rows[i], 'data-wl-vid') !== vid) continue;
      var input = qInput(rows[i]);
      if (input) { input.value = it.quantity; input.setAttribute('data-wl-prev', String(it.quantity)); }
      rows[i].setAttribute('data-wl-unit-final', String(it.final_price));
      var fe = rows[i].querySelector('.hdt-mini-cart__price hdt-price .hdt-money, .hdt-mini-cart__price .hdt-price .hdt-money');
      if (fe) fe.textContent = fmtCents(it.final_price);   /* server's own unit price */
      syncQtyButtons(rows[i]);
      return rows[i];
    }
    return false;
  }
  /* drop a product from the wishlist without going through the theme's button (which
     navigates away when the wishlist page is underneath) */
  function unwishPid(pid) {
    if (!pid) return;
    try {
      var key = 'theme4:wishlist:id';
      var list = (localStorage.getItem(key) || '').split(',').filter(Boolean);
      var i = list.indexOf(String(pid));
      if (i > -1) {
        list.splice(i, 1);
        localStorage.setItem(key, list.toString());
        document.dispatchEvent(new CustomEvent('theme4:wishlist:update', { bubbles: true, detail: list }));
      }
    } catch (e) {}
    try {
      var arr = JSON.parse(sessionStorage.getItem('wl:cart-wished') || '[]');
      var out = arr.filter(function (z) { return String(z.pid) !== String(pid); });
      if (out.length !== arr.length) sessionStorage.setItem('wl:cart-wished', JSON.stringify(out));
    } catch (e) {}
  }
  /* confirm on the card itself instead of re-shuffling the carousel */
  function flashAdded(btn) {
    if (!btn || btn.__wlFlash) return;
    var original = btn.innerHTML;
    btn.__wlFlash = true;
    btn.classList.add('is-added');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>Added';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.innerHTML = original;
      btn.__wlFlash = false;
    }, 1700);
  }
  /* Keep the shopper looking where the new line will land - it is prepended, so the
     top of the list. Purely a scroll; nothing is rendered ahead of the server. */
  function scrollListToTop() {
    var d = dlg(); if (!d) return;
    var scroller = d.querySelector('[data-hdt-scroll-me], .hdt-mini-cart__sroll');
    if (scroller && scroller.scrollTop > 0) {
      try { scroller.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { scroller.scrollTop = 0; }
    }
  }

  /* True when the line for this variant is already at (or past) the stock cap its own
     quantity stepper enforces. Reads the same data-max the stepper reads, so the two
     controls can never disagree. */
  function atStockCap(vid) {
    var rows = rowsLive();
    for (var i = 0; i < rows.length; i++) {
      if (attrInt(rows[i], 'data-wl-vid') !== vid) continue;
      var input = qInput(rows[i]); if (!input) return false;
      var max = parseInt(input.getAttribute('data-max'), 10);
      if (isNaN(max) || max <= 0 || max >= 9999) return false;
      return (parseInt(input.value, 10) || 0) >= max;
    }
    return false;
  }
  /* The card's "you already have all of it" state. Shared by the pre-flight cap check
     and the server's 422, so both look identical to the shopper. */
  function showMaxed(btn) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    var card = btn.closest('.hdt-minicart-recommendations__item');
    if (card) card.classList.add('wl-rec-maxed');
    btn.classList.add('is-maxed');
    btn.setAttribute('disabled', '');
    btn.innerHTML = 'In cart';
    var infos = card && card.querySelector('.hdt-minicart-recommendations__item--infos');
    if (infos && !infos.querySelector('.wl-rec-maxmsg')) {
      var m = document.createElement('span');
      m.className = 'wl-rec-maxmsg';
      m.textContent = 'Max available is already in your cart';
      infos.appendChild(m);
    }
  }
  var recSeq = 0;
  function onRecAdd(btn) {
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-maxed')) return true;
    var vid = parseInt(btn.getAttribute('data-vid'), 10);
    if (!vid) return false;                       /* handle-only pick → let the native path resolve it */
    var wishedSlide = btn.closest('.wl-wished-slide');
    var wishedPid = wishedSlide ? wishedSlide.getAttribute('data-pid') : null;
    /* A variant already in the cart only gets its quantity bumped - no new card - and
       the add response alone carries that line's figures, so skip the markup entirely. */
    var alreadyInCart = rowsLive().some(function (r) { return attrInt(r, 'data-wl-vid') === vid; });
    /* The stepper refuses to go past data-max, but Add to cart used to ignore it, so a
       shopper could tap the card and push a line to 3 while its own control showed
       "Only 1 left" and a greyed plus. Shopify accepts those adds (the variant oversells),
       so the server will not stop it - the cap has to be honoured here too, or the two
       controls contradict each other. Refuse before spending a request. */
    if (alreadyInCart && atStockCap(vid)) { showMaxed(btn); return true; }
    btn.classList.add('is-loading');
    scrollListToTop();
    var seq = ++recSeq;
    var body = { id: vid, quantity: 1 };
    queueCartWork(function () {
      return postJSON('/cart/add.js', alreadyInCart ? withMoney(body) : withNewLineAndMoney(body));
    })
      .then(function (data) {
        if (seq !== recSeq) return;
        btn.classList.remove('is-loading');
        var landed = alreadyInCart ? bumpRowFromResponse(data, vid) : insertAddedRow(data, vid);
        var okMoney = landed && applyExactMoney(parseMoneyEl(data));
        if (!landed || !okMoney) {
          /* structural change (empty cart filling, a bill row appearing) or anything we
             cannot reconcile - take the authoritative render, keeping the carousel node
             so it cannot re-init and flicker. */
          if (api() && api().reload) api().reload({ keepRecs: true }).then(syncAllQtyButtons);
        } else if (alreadyInCart) {
          animateBump(vid);
        } else {
          animateArrival(landed.added);
        }
        syncAllQtyButtons();
        if (wishedPid) unwishPid(wishedPid);
        flashAdded(btn);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        /* 422 = already at the stock limit. Reuse the drawer's own "In cart" state
           rather than inventing a second visual language for it. */
        if (err && err.res && err.res.status === 422) {
          showMaxed(btn);
        } else fail();
      });
    return true;
  }
  function reduceMotion() {
    try { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  /* The stack opens up and the new card rises into the gap from under the cards above. */
  function animateArrival(row) {
    if (!row || reduceMotion()) return;
    var h = row.offsetHeight;
    row.classList.add('wl-opt-anim', 'wl-opt-arriving');
    row.style.height = '0px';
    row.getBoundingClientRect();                 /* flush the closed start state */
    requestAnimationFrame(function () {
      row.classList.remove('wl-opt-arriving');
      row.style.height = h + 'px';
    });
    setTimeout(function () { row.classList.remove('wl-opt-anim'); row.style.height = ''; }, 700);
  }
  /* Existing line that only gained a unit - nothing arrived, so pulse it instead. */
  function animateBump(vid) {    if (reduceMotion()) return;
    var rows = rowsLive(), row = null;
    for (var i = 0; i < rows.length; i++) { if (attrInt(rows[i], 'data-wl-vid') === vid) { row = rows[i]; break; } }
    if (!row) return;
    row.classList.add('wl-opt-bumped');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { row.classList.add('wl-opt-arrived'); });
    });
    setTimeout(function () { row.classList.remove('wl-opt-bumped', 'wl-opt-arrived'); }, 900);
  }

  /* Product features outside this optimizer may mutate the cart while the drawer is
     open. Expose only the two structural operations they need, keeping all markup,
     exact-money and animation rules owned here. Callers still retain their full-render
     fallback when the optimizer is disabled or a structural guard rejects the update. */
  window.wlCartOptAPI = window.wlCartOptAPI || {};
  window.wlCartOptAPI.applyAddedLine = function (data, vid) {
    vid = parseInt(vid, 10);
    if (!vid) return false;
    var landed = insertAddedRow(data, vid);
    var ok = landed && applyExactMoney(parseMoneyEl(data));
    if (!ok) return false;
    animateArrival(landed.added);
    syncAllQtyButtons();
    return true;
  };
  window.wlCartOptAPI.applyRemovedLine = function (data, vid) {
    vid = String(vid || '');
    var row = rowsLive().filter(function (candidate) {
      return String(candidate.getAttribute('data-wl-vid') || '') === vid;
    })[0];
    if (!row || !data || !Array.isArray(data.items)) return false;
    var remaining = rowsLive().filter(function (candidate) { return candidate !== row; });
    if (remaining.length !== data.items.length) return false;
    for (var i = 0; i < remaining.length; i++) {
      if (String(remaining[i].getAttribute('data-wl-vid')) !== String(data.items[i].variant_id)) return false;
    }
    row.setAttribute('data-wl-gone', '');
    animateOut(row);
    dropRow(row);
    var ok = applyExactLines(data) && applyExactMoney(parseMoneyEl(data));
    if (!ok) return false;
    renumberLines();
    syncAllQtyButtons();
    return true;
  };

  /* ============ GLOBAL ADD-TO-CART (home / collection / product / quick view) =======
     Everything OUTSIDE the drawer and /cart still used the theme's NATIVE path, which
     appends the whole cart-drawer section to /cart/add.js. Measured from a home card:
     5 requests / 316KB (add.js 149KB carrying the drawer, plus a 161KB recommendations
     refetch that the drawer re-render triggers) taking 1.3-2.1s. The drawer's own add
     does the same job in ~10KB, so route these forms through it.

     WHY A CAPTURE-PHASE `submit` ON document WORKS: the theme's ProductForm binds
     `submit` on the FORM itself in the bubble phase, so we run first and can stop it.
     `new FormData(form)` is EXACTLY what the native handler builds, so id / quantity /
     properties / selling_plan carry over untouched — the only thing we change is which
     SECTIONS the response carries.

     DELIBERATELY CONSERVATIVE — every uncertain case is handed back to the native path
     rather than guessed at, because a wrong optimisation here is a lost sale:
       - empty cart (needs the real Liquid render to replace the empty state)
       - bundle forms (ProductFormBundle computes its own totals)
       - a line already at its stock cap (the theme's own 422 message + wl-atc-maxqty
         styling must still appear exactly as before)
       - forms inside #CartDrawer or #hdt-page-cart (already optimised, and the gift-wrap
         form there carries action_added="no", i.e. different post-add behaviour) */
  function postForm(url, fd) {
    /* same invalidation discipline as postJSON — a warmed /cart.js copy feeds the
       destructive clear->add rebuild, so any mutation must drop it */
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) invalidateCart();
    /* NEVER set Content-Type for FormData; the browser must add the multipart boundary */
    return fetch(url, { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) {
        if (!r.ok) { var er = new Error('http-' + r.status); er.res = r; throw er; }
        return r.text().then(function (t) { return JSON.parse(t); });
      });
  }
  /* Open via the theme's OWN trigger, never dialog.showModal() — the theme's opener also
     applies the page scroll-lock, and bypassing it leaves a phantom second scrollbar. */
  function openDrawerNow() {
    var d = dlg(); if (!d || d.open) return;
    var t = document.querySelector('[aria-controls="CartDrawer"], [data-hdt-action="open-cart"], .hdt-header__action--cart');
    if (t) t.click();
  }
  function eligibleAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return false;
    if (form.closest('#CartDrawer') || form.closest('#hdt-page-cart')) return false;
    if (form.closest('product-form-bundle') || form.querySelector('[update-total]')) return false;
    return true;
  }
  var gAddSeq = 0;
  function onGlobalAdd(form) {
    if (!eligibleAddForm(form)) return false;
    if (!dlg() || !rowsLive().length) return false;      /* empty cart → native render */
    var fd; try { fd = new FormData(form); } catch (e) { return false; }
    var vid = parseInt(fd.get('id'), 10);
    if (!vid) return false;
    var alreadyInCart = rowsLive().some(function (r) { return attrInt(r, 'data-wl-vid') === vid; });
    if (alreadyInCart && atStockCap(vid)) return false;  /* let the theme show its own cap message */

    var btn = form.querySelector('[type="submit"][name="add"], .hdt-product-form__submit');
    if (btn) { btn.setAttribute('disabled', 'true'); btn.setAttribute('aria-busy', 'true'); }
    /* comma-separated section list, the form-encoded equivalent of withNewLineAndMoney */
    fd.append('sections', alreadyInCart ? MONEY_SID : (NEWLINE_SID + ',' + MONEY_SID));
    fd.append('sections_url', '/');
    var seq = ++gAddSeq;
    /* queueCartWork is NOT optional: it serialises this against every other cart
       mutation. An add landing inside a size swap's clear->add window is exactly the
       interleaving that destroyed carts before. */
    queueCartWork(function () { return postForm('/cart/add.js', fd); })
      .then(function (data) {
        if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
        if (seq !== gAddSeq) return;
        var landed = alreadyInCart ? bumpRowFromResponse(data, vid) : insertAddedRow(data, vid);
        var okMoney = landed && applyExactMoney(parseMoneyEl(data));
        if (!landed || !okMoney) {
          /* anything structural we cannot reconcile → authoritative render, keeping the
             carousel node so it cannot re-init and flicker */
          if (api() && api().reload) api().reload({ keepRecs: true }).then(syncAllQtyButtons);
        } else if (alreadyInCart) { animateBump(vid); } else { animateArrival(landed.added); }
        syncAllQtyButtons();
        openDrawerNow();
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
        if (seq !== gAddSeq) return;
        fail();
      });
    return true;
  }
  document.addEventListener('submit', function (e) {
    if (!window.wlDrawerAPI) return;             /* inline drawer not ready → leave it native */
    if (e.isTrusted === false) return;
    var form = e.target;
    var taken = false;
    try { taken = onGlobalAdd(form); } catch (err) { taken = false; }
    if (taken) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* ============= capture-phase interception (pre-empts old/core) ========== */
  document.addEventListener('click', function (e) {
    if (!window.wlDrawerAPI) return;              /* inline drawer not ready → don't intercept */
    /* CRITICAL: the drawer fires SYNTHETIC heart clicks after every render
       (wlUnwishCartItems / wlCartHeartUnwish). Never treat those as user intent —
       doing so removed cart lines in a feedback loop. Only real clicks are handled. */
    if (e.isTrusted === false || window.__wlSkipHeart) return;
    var t = e.target; if (!t || !t.closest || !inDrawer(t)) return;

    var recAdd = t.closest('[data-wl-rec-add]');
    if (recAdd) {
      if (onRecAdd(recAdd)) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }

    /* Opening a size menu is the earliest reliable signal that a variant swap may be
       coming. Warm the cart JSON now so the swap itself is just clear -> add.
       Deliberately does NOT preventDefault - the drawer still opens the menu. */
    if (t.closest('[data-wl-size-toggle]')) { warmCart(); return; }

    var wish = t.closest('.wl-ci-wish');
    if (wish) { if (onWishHeart(wish)) { e.preventDefault(); e.stopImmediatePropagation(); } return; }

    var rmCoupon = t.closest('.hdt-discount-remove, .wl-coupon-x');
    if (rmCoupon && rmCoupon.getAttribute('data-discount-code')) {
      e.preventDefault(); e.stopImmediatePropagation(); onCouponRemove(rmCoupon); return;
    }
    var applyCoupon = t.closest('[data-cart-discount-apply]');
    if (applyCoupon) { e.preventDefault(); e.stopImmediatePropagation(); onCouponApply(applyCoupon); return; }

    var opt = t.closest('.wl-size__opt');
    if (opt) { e.preventDefault(); e.stopImmediatePropagation(); onSizeOpt(opt); return; }

    var qbtn = t.closest('.hdt-quantity__button');
    if (qbtn && t.closest('hdt-quantity-wrapp, .hdt-mini-cart__quantity')) { e.preventDefault(); e.stopImmediatePropagation(); onQtyBtn(qbtn); return; }
  }, true);

  document.addEventListener('change', function (e) {
    if (!window.wlDrawerAPI) return;
    var t = e.target; if (!t || !t.matches || e.isTrusted === false) return;
    if (inDrawer(t) && t.matches('input[name="updates[]"]')) { e.stopImmediatePropagation(); onQtyInputChange(t); }
  }, true);

  document.addEventListener('input', function (e) {
    if (!window.wlDrawerAPI) return;
    var t = e.target; if (!t || !t.matches || e.isTrusted === false) return;
    if (inDrawer(t) && t.matches('input[name="updates[]"]')) { e.stopImmediatePropagation(); } /* block core live-update; commit on change */
  }, true);

  /* ======================================================================
     CART PAGE (#hdt-page-cart) — same exact-money rules as the drawer.
     wl-cart.js normally predicts totals from the DOM (recalcOptimistic) and
     formats money with Math.round(cents/100), which silently DROPS PAISE
     (₹2,338.20 → "₹2,338"). Here every figure is the server's own string.
     ====================================================================== */
  function pageRoot() { return document.getElementById('hdt-page-cart'); }
  function inPage(el) { var r = pageRoot(); return !!(r && el && r.contains(el)); }
  function papi() { return window.wlCartAPI || null; }
  function pageRows() { var r = pageRoot(); return r ? [].slice.call(r.querySelectorAll('.wl-cart-item:not([data-removing])')) : []; }

  /* Writes the server's figures verbatim into the cart page summary. Returns false
     when the page structure can't represent them, so the caller re-renders instead. */
  function applyPageMoney(moneyEl) {
    var r = pageRoot(); if (!r || !moneyEl) return false;
    var box = r.querySelector('[data-wl-price]'); if (!box) return false;
    var lineCount = parseInt(moneyEl.getAttribute('data-line-count'), 10);
    if (lineCount !== pageRows().length) return false;
    var total = parseInt(moneyEl.getAttribute('data-total'), 10) || 0;
    var orig = parseInt(moneyEl.getAttribute('data-orig-total'), 10) || 0;
    var savings = parseInt(moneyEl.getAttribute('data-savings'), 10) || 0;
    var prodSav = parseInt(moneyEl.getAttribute('data-prod-savings'), 10) || 0;
    var cartDisc = parseInt(moneyEl.getAttribute('data-cart-discount'), 10) || 0;
    var count = moneyEl.getAttribute('data-item-count') || '0';

    box.setAttribute('data-srv-mrp', String(orig));
    box.setAttribute('data-srv-total', String(total));
    box.setAttribute('data-srv-saved', String(savings));
    box.setAttribute('data-srv-cartdisc', String(cartDisc));

    var set = function (sel, txt) { var e = r.querySelector(sel); if (e) e.textContent = txt; };
    set('[data-wl-pd-label]', count + ' ' + (count === '1' ? 'item' : 'items'));
    set('[data-wl-pd-mrp]', moneyEl.getAttribute('data-money-orig') || '');
    set('[data-wl-pd-total]', moneyEl.getAttribute('data-money-total') || '');
    set('[data-wl-sticky-total]', moneyEl.getAttribute('data-money-total') || '');
    set('[data-wl-pd-saved]', moneyEl.getAttribute('data-money-savings') || '');

    var discEl = r.querySelector('[data-wl-pd-disc]');
    if (discEl) discEl.innerHTML = '\u2212 ' + (moneyEl.getAttribute('data-money-prod-savings') || '');
    var discRow = r.querySelector('[data-wl-pd-discrow]'); if (discRow) discRow.style.display = prodSav > 0 ? '' : 'none';
    var savedRow = r.querySelector('[data-wl-pd-savedrow]'); if (savedRow) savedRow.style.display = savings > 0 ? '' : 'none';
    /* Rebuild one row per cart-level discount from the server's own lists, so a code
       stacking with an automatic offer stays itemised here exactly as it does in the
       drawer. Writing the whole cart discount into a single row was wrong the moment
       there were two. */
    var pTitles = splitList(moneyEl.getAttribute('data-disc-titles'));
    var pAmts = splitList(moneyEl.getAttribute('data-disc-amounts'));
    var pApi = (window.wlCartPageAPI && window.wlCartPageAPI.syncDiscRows) || null;
    var pBox = r.querySelector('[data-wl-price]');
    if (pApi && pBox && pTitles.length === pAmts.length) {
      try {
        pApi(pBox, pTitles.map(function (t, i) {
          return { title: t, amount: parseInt(pAmts[i], 10) || 0 };
        }), cartDisc);
      } catch (e) {}
    }
    if (papi() && papi().syncCount) try { papi().syncCount(Number(count)); } catch (e) {}
    applyRewards(moneyEl.getAttribute('data-subtotal'), moneyEl.getAttribute('data-cart-discount'));
    return true;
  }

  /* Per-line figures, verbatim from the cart JSON. */
  function applyPageLines(cart) {
    var rows = pageRows();
    if (!cart || !cart.items || rows.length !== cart.items.length) return false;
    for (var i = 0; i < rows.length; i++) {
      if (String(rows[i].getAttribute('data-vid')) !== String(cart.items[i].variant_id)) return false;
    }
    cart.items.forEach(function (it, i) {
      var row = rows[i];
      var inp = row.querySelector('.wl-qty__val');
      if (inp) {
        inp.value = it.quantity;
        var mn = parseInt(inp.getAttribute('data-min'), 10) || 1;
        var mx = parseInt(inp.getAttribute('data-max'), 10) || 9999;
        var wrap = inp.closest('[data-wl-qty]');
        if (wrap) {
          var dbtn = wrap.querySelector('[data-wl-dec]'), ubtn = wrap.querySelector('[data-wl-inc]');
          if (dbtn) dbtn.disabled = it.quantity <= mn;
          if (ubtn) ubtn.disabled = it.quantity >= mx;
        }
      }
      row.setAttribute('data-unit-sell', String(it.final_price));
      var now = row.querySelector('.wl-cart-item__now');
      if (now) now.textContent = fmtCents(it.final_price);   /* exact, paise preserved */
    });
    return true;
  }

  /* `/cart/change.js` already replies with the FULL cart object, so one request is
     enough - no follow-up /cart.js round trip. */
  function pageRenderExact(url, body) {
    return queueCartWork(function () { return postJSON(url, withMoney(body)); }).then(function (data) {
      var moneyEl = parseMoneyEl(data);
      var ok = applyPageLines(data) && applyPageMoney(moneyEl);
      if (papi() && papi().refreshSizeAvailability) try { papi().refreshSizeAvailability(); } catch (e) {}
      if (!ok) return pageFullRender();
    }).catch(function () { pageFail(); });
  }
  /* Structural change → the page's own server render (authoritative, re-inits everything) */
  function pageFullRender(body) {
    if (papi() && papi().postCart) return papi().postCart('/cart/update.js', body || { updates: {} });
    location.reload(); return Promise.resolve();
  }
  function pageFail() {
    if (papi() && papi().notice) try { papi().notice(); } catch (e) {}
    if (papi() && papi().reconcile) try { papi().reconcile(); } catch (e) {}
  }

  var pgSeq = {};
  function pageQty(line, next, row) {
    var seq = (pgSeq[line] = (pgSeq[line] || 0) + 1);
    pageRenderExact('/cart/change.js', { line: line, quantity: next });
  }

  /* Shopify re-indexes the surviving lines after a removal, so the page's
     data-line attributes must follow or the next action hits the wrong line. */
  function pageRenumberLines() {
    pageRows().forEach(function (row, i) {
      var n = String(i + 1);
      if (row.hasAttribute('data-line')) row.setAttribute('data-line', n);
      [].slice.call(row.querySelectorAll('[data-line]')).forEach(function (el) { el.setAttribute('data-line', n); });
    });
  }
  /* Removal, cheaply: the row leaving is a DOM job, not a reason to re-render the
     whole cart section (~66KB). Just as importantly the request is fired NOW rather
     than from the animation's completion callback - previously the network wait
     started only after the ~330ms collapse had finished, so the two costs added up
     instead of overlapping. */
  function pageCommitRemoval(line, row) {
    if (row) {
      row.setAttribute('data-removing', '1');
      /* slide it off the deck first so the motion covers the round trip */
      try {
        if (!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
          row.classList.add('is-removing');
          requestAnimationFrame(function () { row.classList.add('wl-opt-slide'); });
        }
      } catch (_) {}
      if (papi() && papi().animateOut) {
        try { papi().animateOut(row, function () { if (row.parentNode) row.parentNode.removeChild(row); }); } catch (_) {}
      }
      if (papi() && papi().showEmptyImmediately) {
        try { papi().showEmptyImmediately(); } catch (_) {}
      }
    }
    return queueCartWork(function () { return postJSON('/cart/change.js', withMoney({ line: line, quantity: 0 })); })
      .then(function (data) {
        /* An empty cart needs the Liquid empty-state markup. */
        if (!data.item_count || !data.items || !data.items.length) return pageFullRender();
        var ok = applyPageLines(data) && applyPageMoney(parseMoneyEl(data));
        if (!ok) return pageFullRender();
        pageRenumberLines();
        if (papi() && papi().refreshSizeAvailability) try { papi().refreshSizeAvailability(); } catch (e) {}
        if (papi() && papi().syncCount) try { papi().syncCount(data.item_count); } catch (e) {}
      })
      .catch(function () { pageFail(); });
  }

  function pageCloseSizeMenus() {
    var r = pageRoot(); if (!r) return;
    r.querySelectorAll('.wl-size.is-open').forEach(function (x) { x.classList.remove('is-open'); });
  }

  /* Swapping a variant needs a cart rebuild (Shopify cannot change a line's variant in
     place). Line order, properties and selling plans are preserved; every figure that
     comes back is the server's own. */
  var pgVarSeq = 0;
  function pageChangeVariant(line, vid, newQty) {
    var seq = ++pgVarSeq;
    /* Same serialised rebuild as the drawer - two quick size changes must never
       interleave, or the second clears a cart it then cannot refill. */
    rebuildCart(function (cart) {
      /* Same rule as the drawer: the SERVER's quantity is the base, never the DOM
         input, which the theme clamps to the variant's current max. `newQty` is treated
         as a CAP (the caller derives it from the target size's stock), not as the
         quantity itself, so a swap can lower the count only when stock demands it. */
      var srvLine = cart.items[line - 1];
      var baseQty = (srvLine && srvLine.quantity) || newQty;
      var want = Math.max(1, Math.min(baseQty, newQty || baseQty));
      return cart.items.map(function (it, idx) {
        var nid = (idx === line - 1) ? vid : it.variant_id;
        var o = { id: nid, quantity: (idx === line - 1) ? want : it.quantity };
        if (it.properties && Object.keys(it.properties).length) o.properties = it.properties;
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) o.selling_plan = it.selling_plan_allocation.selling_plan.id;
        return o;
      });
    }).then(function (data) {
      if (seq !== pgVarSeq) return;
      var rebuilt = (data && data.items) ? { items: data.items.slice().reverse() } : null;
      var ok = rebuilt && applyPageLines(rebuilt) && applyPageMoney(parseMoneyEl(data));
      if (papi() && papi().refreshSizeAvailability) try { papi().refreshSizeAvailability(); } catch (e) {}
      if (!ok) return pageFullRender();
    }).catch(function () { if (seq === pgVarSeq) pageFail(); });
  }

  document.addEventListener('click', function (e) {
    if (!window.wlCartAPI) return;
    if (e.isTrusted === false) return;
    var t = e.target; if (!t || !t.closest || !inPage(t)) return;

    /* warm the cart JSON the moment a size menu opens, same as the drawer */
    if (t.closest('[data-wl-size-toggle]')) { warmCart(); return; }

    var inc = t.closest('[data-wl-inc]'), dec = t.closest('[data-wl-dec]');
    if (inc || dec) {
      var btn = inc || dec;
      if (btn.disabled) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var wrap = btn.closest('[data-wl-qty]'); var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-line'), 10);
      var min = parseInt(input.getAttribute('data-min'), 10) || 1;
      var max = parseInt(input.getAttribute('data-max'), 10) || 9999;
      var cur = parseInt(input.value, 10) || 1;
      var next = inc ? cur + 1 : cur - 1;
      e.preventDefault(); e.stopImmediatePropagation();
      if (next < min || next > max) return;
      /* control state only — never a money figure */
      input.value = next;
      var d1 = wrap.querySelector('[data-wl-dec]'), u1 = wrap.querySelector('[data-wl-inc]');
      if (d1) d1.disabled = next <= min;
      if (u1) u1.disabled = next >= max;
      if (papi() && papi().refreshSizeAvailability) try { papi().refreshSizeAvailability(); } catch (_) {}
      pageQty(line, next, btn.closest('.wl-cart-item'));
      return;
    }

    /* size swap on the cart page: control state echoes, money comes from the server */
    var popt = t.closest('.wl-size__opt');
    if (popt) {
      e.preventDefault(); e.stopImmediatePropagation();
      var pbox = popt.closest('.wl-size');
      var prow = popt.closest('.wl-cart-item');
      if (!pbox || !prow) return;
      pageCloseSizeMenus();
      if (popt.disabled || popt.classList.contains('is-out') || popt.classList.contains('is-inbag') || popt.classList.contains('is-sel')) return;
      var pline = parseInt(pbox.getAttribute('data-line'), 10);
      var pInp = prow.querySelector('.wl-qty__val');
      var pqty = pInp ? (parseInt(pInp.value, 10) || 1) : 1;
      var pvid = parseInt(popt.getAttribute('data-vid'), 10);
      var pmax = parseInt(popt.getAttribute('data-max'), 10); if (isNaN(pmax) || pmax < 0) pmax = 999;
      if (!pline || !pvid) return;
      /* inventory guard: the target size may already be on another line */
      var used = 0;
      pageRows().forEach(function (x) {
        if (x === prow) return;
        if (String(x.getAttribute('data-vid')) === String(pvid)) { var i2 = x.querySelector('.wl-qty__val'); used += i2 ? (parseInt(i2.value, 10) || 0) : 0; }
      });
      var allowed = pmax - used;
      if (allowed <= 0) { if (papi() && papi().notice) papi().notice(used > 0 ? 'That size is already in your bag' : 'That size is out of stock'); return; }
      var pNewQty = pqty; if (pNewQty > allowed) { pNewQty = allowed; if (papi() && papi().notice) papi().notice('Only ' + allowed + ' left in that size'); }
      /* control state only */
      var ptog = prow.querySelector('[data-wl-size-toggle] span'); if (ptog) ptog.textContent = (popt.textContent || '').trim();
      prow.setAttribute('data-vid', String(pvid));
      pbox.setAttribute('data-cur', String(pvid)); pbox.setAttribute('data-qty', String(pNewQty));
      prow.querySelectorAll('.wl-size__opt').forEach(function (o) { o.classList.toggle('is-sel', String(o.getAttribute('data-vid')) === String(pvid)); });
      if (pInp) { pInp.value = pNewQty; pInp.setAttribute('data-max', String(pmax)); }
      pageChangeVariant(pline, pvid, pNewQty);
      return;
    }

    var rem = t.closest('[data-wl-remove]'), mv = t.closest('[data-wl-move]');
    if (rem || mv) {
      e.preventDefault(); e.stopImmediatePropagation();
      var el = rem || mv;
      var rline = parseInt(el.getAttribute('data-line'), 10);
      var rrow = el.closest('.wl-cart-item');
      if (mv && papi() && papi().addWishlist) try { papi().addWishlist(el.getAttribute('data-pid')); } catch (_) {}
      pageCommitRemoval(rline, rrow);
      return;
    }
  }, true);

  function markPrev() {
    var d = dlg(); if (!d) return;
    d.querySelectorAll('.hdt-mini-cart__items hdt-line-item input[name="updates[]"]').forEach(function (i) {
      attrIf(i, 'data-wl-prev', i.value);
    });
  }
  function refreshControls() { syncAllQtyButtons(); markPrev(); }
  (function watch() {
    var d = dlg();
    if (!d) { setTimeout(watch, 300); return; }
    refreshControls();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refreshControls, 90); })
      .observe(d, { childList: true, subtree: true });
    new MutationObserver(function () { if (d.open) refreshControls(); })
      .observe(d, { attributes: true, attributeFilter: ['open'] });
  })();
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (t && t.matches && inDrawer(t) && t.matches('input[name="updates[]"]')) markPrev();
  }, true);

})();
